
import * as verilogGrammar from "../../../src/Renderer/VerilogComponent/VerilogGrammar.js";
import nearley from "nearley";
import { parseFromFile, fix } from "../../../src/Renderer/VerilogComponent/parser.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { LoadedComponent, CustomComponentType, Project, SheetInfo, CCForm, ShiftComponentType, NBitsArithmetic, ComponentType, PortType, Connection, Port, Component, Port_$reflection, Connection_$reflection, Component_$reflection } from "../Common/CommonTypes.js";
import { option_type, union_type, record_type, int32_type, list_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { ExpressionDU, UnaryDU, unrollForLoops, getItem, convertModule, getNonBlockingAssignmentsWithLocation, getBlockingAssignments, ASTNode, getContAssignments, foldAST, Number$, getPrimaryLocation, BaseDU, Number$_$reflection, PrimaryDU_$reflection, OperatorDU_$reflection, evalExpr, tryEvalConst, getPrimaryName, getPrimaryRange, evalExprWithParams } from "./VerilogAST.js";
import { JsonHelpers_stateToJsonString, IdAllocator_newComponentId, IdAllocator_newConnectionId, IdAllocator_newPortId } from "../Common/Helpers.js";
import { cons, reduce, tryFindIndex, tryFind as tryFind_1, last as last_1, sortBy, contains as contains_1, reverse, chunkBySize, isEmpty, ofSeq as ofSeq_1, iterate, map as map_6, filter, zip, splitAt, tail as tail_3, head as head_1, fold, ofArray, item as item_2, mapIndexed, append, length, singleton, collect, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { map as map_8, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { split, toText, printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { FSharpMap__Remove, containsKey, fold as fold_3, FSharpMap__get_Keys, toList as toList_1, FSharpMap__get_Values, empty as empty_2, filter as filter_1, keys, ofList, add as add_1, FSharpMap__TryFind, tryFind, find } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { parse, op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { stringHash, defaultOf, comparePrimitives, int32ToString, compare, curry3, uncurry2, safeHash, equals, Exception } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { sortBy as sortBy_1, append as append_1, chunkBySize as chunkBySize_1, choose, fold as fold_2, tail as tail_4, tryItem, equalsWith, map as map_7, item as item_3 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { ofList as ofList_1, ofArray as ofArray_1, union, remove, ofSeq, empty as empty_1, fold as fold_1, add, contains } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { value as value_1, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { dbg, warn } from "../Shared/Log.js";
import { compare as compare_1, fromInt32, toInt64_unchecked, fromInt64, fromOne, op_LeftShift, op_Subtraction, fromZero } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { toDecimal, strToIntCheckWidth } from "../Simulator/NumberHelpers.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { getDeclarations, getWireSizeMap, getModuleInstantiationStatements, getModuleInstantiationOutputPrimaries } from "./ErrorCheckHelpers.js";
import { StringModule_Concat, MapModule_ValuesL } from "../Common/EEExtensions.js";
import { getParamMap, getArraySizeMap, getPortSizeAndLocationMap } from "./ErrorCheck.js";
import { tryLoadComponentFromPath, writeFile, pathJoin, tryReadFileSync } from "../Interface/FilesIO.js";
import { SimpleJson_tryParse } from "../Common/SimpleJson/SimpleJson.js";
import { Convert_fromJson } from "../Common/SimpleJson/Json.Converter.js";
import { createTypeInfo } from "../Common/SimpleJson/TypeInfo.Converter.js";
import { VerilogInput_$reflection, ParserOutput_$reflection } from "./VerilogTypes.js";
import { Result_Bind } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { openFileInProject } from "../UI/MenuHelpers.js";
import { layoutCanvas } from "../DrawBlock/SheetLayout.js";




export class Circuit extends Record {
    constructor(Comps, Conns, Out, OutWidth) {
        super();
        this.Comps = Comps;
        this.Conns = Conns;
        this.Out = Out;
        this.OutWidth = (OutWidth | 0);
    }
}

export function Circuit_$reflection() {
    return record_type("SheetCreator.Circuit", [], Circuit, () => [["Comps", list_type(Component_$reflection())], ["Conns", list_type(Connection_$reflection())], ["Out", Port_$reflection()], ["OutWidth", int32_type]]);
}

export class Slice extends Record {
    constructor(MSB, LSB) {
        super();
        this.MSB = (MSB | 0);
        this.LSB = (LSB | 0);
    }
}

export function Slice_$reflection() {
    return record_type("SheetCreator.Slice", [], Slice, () => [["MSB", int32_type], ["LSB", int32_type]]);
}

export class LHSType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OutputPort", "Wire"];
    }
    static OutputPort = new LHSType(0, []);
    static Wire = new LHSType(1, []);
}

export function LHSType_$reflection() {
    return union_type("SheetCreator.LHSType", [], LHSType, () => [[], []]);
}

export class BitMapping extends Record {
    constructor(Slice, Circuit, LHSType) {
        super();
        this.Slice = Slice;
        this.Circuit = Circuit;
        this.LHSType = LHSType;
    }
}

export function BitMapping_$reflection() {
    return record_type("SheetCreator.BitMapping", [], BitMapping, () => [["Slice", Slice_$reflection()], ["Circuit", Circuit_$reflection()], ["LHSType", LHSType_$reflection()]]);
}

/**
 * Helper function to find a port's width from the range definition of IODecl
 */
export function getWidthFromRange(range, paramMap) {
    if (range != null) {
        return (evalExprWithParams(range.Start, paramMap) + 1) | 0;
    }
    else {
        return 1;
    }
}

/**
 * Create a component (type: Component) based on the parameters given
 */
export function createComponent$0027(id, compType, name, inputPorts, outputPorts) {
    return new Component(id, compType, name.toLocaleUpperCase(), inputPorts, outputPorts, 0, 0, 30, 30, undefined, undefined);
}

/**
 * Create a port (type: Port) based on the parameters given
 */
export function createPort(hostId, portType, portNumber) {
    return new Port(IdAllocator_newPortId(), portNumber, portType, hostId);
}

/**
 * Connect source with target returning the connection (type: Connection)
 */
export function createConnection(source, target) {
    const source$0027 = new Port(source.Id, undefined, source.PortType, source.HostId);
    const target$0027 = new Port(target.Id, undefined, target.PortType, target.HostId);
    return new Connection(IdAllocator_newConnectionId(), source$0027, target$0027, empty());
}

export function createPortList(ofType, number, hostId) {
    return collect((i) => singleton(createPort(hostId, ofType, i)), toList(rangeDouble(0, 1, number - 1)));
}

/**
 * Main component creation function
 * Find all the parameters required for component creation
 * based on the component Type and the name(label) given
 * Returns the created component
 */
export function createComponent(compType, name) {
    let patternInput;
    switch (compType.tag) {
        case 6:
        case 25:
        case 47:
        case 8:
        case 23:
        case 3: {
            patternInput = [1, 1];
            break;
        }
        case 1:
        case 2: {
            patternInput = [1, 0];
            break;
        }
        case 22:
        case 24:
        case 21:
        case 46:
        case 27: {
            patternInput = [2, 1];
            break;
        }
        case 11: {
            patternInput = [3, 1];
            break;
        }
        case 17: {
            patternInput = [3, 2];
            break;
        }
        case 10: {
            patternInput = [compType.fields[1], 1];
            break;
        }
        case 48:
        case 0:
        case 7: {
            patternInput = [0, 1];
            break;
        }
        case 33: {
            patternInput = [1, 1];
            break;
        }
        case 38: {
            patternInput = [0, 1];
            break;
        }
        case 39: {
            patternInput = [1, 1];
            break;
        }
        case 41: {
            patternInput = [3, 1];
            break;
        }
        case 26: {
            const custom = compType.fields[0];
            patternInput = [length(custom.InputLabels), length(custom.OutputLabels)];
            break;
        }
        default:
            patternInput = toFail(`Undefined component properties ${compType}`);
    }
    const id = IdAllocator_newComponentId();
    return createComponent$0027(id, compType, name, createPortList(PortType.Input, patternInput[0], id), createPortList(PortType.Output, patternInput[1], id));
}

export function extractCircuit(input_, input__1, input__2, input__3) {
    return input_;
}

/**
 * Join input ports of topCircuit with inCircuits
 */
export function joinCircuits(inCircuits, inPorts, topCircuit) {
    const allConns = append(append(topCircuit.Conns, mapIndexed((index, inputPortId) => createConnection(item_2(index, inCircuits).Out, inputPortId), inPorts)), collect((c) => c.Conns, inCircuits));
    return new Circuit(append(topCircuit.Comps, collect((circ) => circ.Comps, inCircuits)), allConns, topCircuit.Out, topCircuit.OutWidth);
}

export function merge2Circuits(c1, c2) {
    const comp = createComponent(ComponentType.MergeWires, "");
    const topCircuit = new Circuit(singleton(comp), empty(), item_2(0, comp.OutputPorts), c1.OutWidth + c2.OutWidth);
    return joinCircuits(ofArray([c1, c2]), ofArray([item_2(0, comp.InputPorts), item_2(1, comp.InputPorts)]), topCircuit);
}

export function joinWithMerge$0027(circuits) {
    return fold(merge2Circuits, head_1(circuits), tail_3(circuits));
}

/**
 * Join a list of circuits with MergeWires components
 */
export function joinWithMerge(lst_mut) {
    joinWithMerge:
    while (true) {
        const lst = lst_mut;
        const merge2Circuits_1 = (tupledArg, tupledArg_1) => {
            const comp = createComponent(ComponentType.MergeWires, "");
            const topCircuit = new Circuit(singleton(comp), empty(), item_2(0, comp.OutputPorts), 0);
            return [joinCircuits(ofArray([tupledArg[0], tupledArg_1[0]]), ofArray([item_2(0, comp.InputPorts), item_2(1, comp.InputPorts)]), topCircuit), tupledArg[1], tupledArg[2], tupledArg[3]];
        };
        const matchValue = length(lst) | 0;
        switch (matchValue) {
            case 1:
                return item_2(0, lst);
            case 2:
                return merge2Circuits_1(item_2(0, lst), item_2(1, lst));
            default: {
                const patternInput = splitAt(2, lst);
                lst_mut = append(singleton(merge2Circuits_1(item_2(0, lst), item_2(1, lst))), patternInput[1]);
                continue joinWithMerge;
            }
        }
        break;
    }
}

/**
 * Extract MSB,LSB from assignment and return as a Slice
 * type Slice = {MSB:int, LSB:int}
 */
export function sliceFromBits(lhs, ioAndWireToCompMap, varSizeMap, paramMap) {
    const matchValue = getPrimaryRange(lhs.PrimaryType, paramMap);
    if (matchValue == null) {
        return new Slice(find(getPrimaryName(lhs.PrimaryType), varSizeMap) - 1, 0);
    }
    else {
        return new Slice(matchValue[0], matchValue[1]);
    }
}

export function evalExprWithVarsAndParams(expr, paramMap, varSizeMap) {
    const strip = (expr_1_mut) => {
        strip:
        while (true) {
            const expr_1 = expr_1_mut;
            let matchResult, e;
            if (expr_1.tag === 13) {
                if (expr_1.fields[0].tag === 2) {
                    matchResult = 0;
                    e = expr_1.fields[0].fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    expr_1_mut = e;
                    continue strip;
                }
                default:
                    return expr_1;
            }
            break;
        }
    };
    const expr_2 = strip(expr);
    let matchResult_1, n, n_1, n_2, id, lhs, op, rhs, lhs_1, op_1, rhs_1, lhs_2, op_2, rhs_2, lhs_3, rhs_3, lhs_4, rhs_4, lhs_5, rhs_5, lhs_6, rhs_6;
    switch (expr_2.tag) {
        case 14: {
            matchResult_1 = 0;
            n = expr_2.fields[0];
            break;
        }
        case 12: {
            if (expr_2.fields[0].tag === 1) {
                matchResult_1 = 1;
                n_1 = expr_2.fields[0].fields[0];
            }
            else {
                matchResult_1 = 11;
            }
            break;
        }
        case 13: {
            switch (expr_2.fields[0].tag) {
                case 1: {
                    matchResult_1 = 2;
                    n_2 = expr_2.fields[0].fields[0];
                    break;
                }
                case 0: {
                    if (expr_2.fields[0].fields[0].tag === 0) {
                        matchResult_1 = 3;
                        id = expr_2.fields[0].fields[0].fields[0];
                    }
                    else {
                        matchResult_1 = 11;
                    }
                    break;
                }
                default:
                    matchResult_1 = 11;
            }
            break;
        }
        case 9: {
            matchResult_1 = 4;
            lhs = expr_2.fields[1];
            op = expr_2.fields[0];
            rhs = expr_2.fields[2];
            break;
        }
        case 10: {
            matchResult_1 = 5;
            lhs_1 = expr_2.fields[1];
            op_1 = expr_2.fields[0];
            rhs_1 = expr_2.fields[2];
            break;
        }
        case 8: {
            matchResult_1 = 6;
            lhs_2 = expr_2.fields[1];
            op_2 = expr_2.fields[0];
            rhs_2 = expr_2.fields[2];
            break;
        }
        case 5: {
            matchResult_1 = 7;
            lhs_3 = expr_2.fields[0];
            rhs_3 = expr_2.fields[1];
            break;
        }
        case 2: {
            matchResult_1 = 8;
            lhs_4 = expr_2.fields[0];
            rhs_4 = expr_2.fields[1];
            break;
        }
        case 3: {
            matchResult_1 = 9;
            lhs_5 = expr_2.fields[0];
            rhs_5 = expr_2.fields[1];
            break;
        }
        case 4: {
            matchResult_1 = 10;
            lhs_6 = expr_2.fields[0];
            rhs_6 = expr_2.fields[1];
            break;
        }
        default:
            matchResult_1 = 11;
    }
    switch (matchResult_1) {
        case 0:
            return tryEvalConst(n) | 0;
        case 1:
            return op_UnaryNegation_Int32(tryEvalConst(n_1)) | 0;
        case 2:
            return tryEvalConst(n_2) | 0;
        case 3: {
            const matchValue = tryFind(id.Name, paramMap);
            if (matchValue == null) {
                const matchValue_1 = tryFind(id.Name, varSizeMap);
                if (matchValue_1 == null) {
                    return toFail(printf("Undefined identifier")) | 0;
                }
                else {
                    return matchValue_1 | 0;
                }
            }
            else {
                return matchValue | 0;
            }
        }
        case 4: {
            const l = evalExprWithVarsAndParams(lhs, paramMap, varSizeMap) | 0;
            const r = evalExprWithVarsAndParams(rhs, paramMap, varSizeMap) | 0;
            switch (op.tag) {
                case 14:
                    return (l + r) | 0;
                case 15:
                    return (l - r) | 0;
                default:
                    throw new Exception("Unsupported additive operator for parameter evaluation");
            }
        }
        case 5: {
            const l_1 = evalExprWithVarsAndParams(lhs_1, paramMap, varSizeMap) | 0;
            const r_1 = evalExprWithVarsAndParams(rhs_1, paramMap, varSizeMap) | 0;
            if (op_1.tag === 16) {
                return (l_1 * r_1) | 0;
            }
            else {
                throw new Exception("Unsupported multiplicative operator for parameter evaluation");
            }
        }
        case 6: {
            const l_2 = evalExprWithVarsAndParams(lhs_2, paramMap, varSizeMap) | 0;
            const r_2 = evalExprWithVarsAndParams(rhs_2, paramMap, varSizeMap) | 0;
            switch (op_2.tag) {
                case 17:
                    return (l_2 << r_2) | 0;
                case 18:
                    return (l_2 >> r_2) | 0;
                case 19:
                    return (l_2 >> r_2) | 0;
                default:
                    throw new Exception("Unsupported shift operator for parameter evaluation");
            }
        }
        case 7:
            return (evalExprWithVarsAndParams(lhs_3, paramMap, varSizeMap) & evalExprWithVarsAndParams(rhs_3, paramMap, varSizeMap)) | 0;
        case 8:
            return (evalExprWithVarsAndParams(lhs_4, paramMap, varSizeMap) | evalExprWithVarsAndParams(rhs_4, paramMap, varSizeMap)) | 0;
        case 9:
            return (evalExprWithVarsAndParams(lhs_5, paramMap, varSizeMap) ^ evalExprWithVarsAndParams(rhs_5, paramMap, varSizeMap)) | 0;
        case 10:
            return ~(evalExprWithVarsAndParams(lhs_6, paramMap, varSizeMap) ^ evalExprWithVarsAndParams(rhs_6, paramMap, varSizeMap)) | 0;
        default:
            throw new Exception("Expression does not evaluate to a constant integer or parameter reference");
    }
}

export function sliceFromWordArray(lhs, varSizeMap, arraySizeMap) {
    const matchValue = lhs.PrimaryType;
    switch (matchValue.tag) {
        case 2:
            return toFail(printf("Not allowed to assign to multiple arrays at once")) | 0;
        case 4:
            return toFail(printf("Not allowed for arrays")) | 0;
        case 1:
            return matchValue.fields[1] | 0;
        case 3:
            return evalExpr(matchValue.fields[1]) | 0;
        case 5: {
            const arrayElem_2 = item_3(0, matchValue.fields[1]);
            if (arrayElem_2.tag === 1) {
                return evalExpr(arrayElem_2.fields[0]) | 0;
            }
            else {
                return arrayElem_2.fields[0] | 0;
            }
        }
        case 6: {
            const arrayElem_3 = item_3(0, matchValue.fields[1]);
            if (arrayElem_3.tag === 1) {
                return evalExpr(arrayElem_3.fields[0]) | 0;
            }
            else {
                return arrayElem_3.fields[0] | 0;
            }
        }
        default:
            return toFail(printf("Not allowed to assign to whole array")) | 0;
    }
}

export function sliceFromBitsArray(lhs, arraySizeMap) {
    const matchValue = lhs.PrimaryType;
    switch (matchValue.tag) {
        case 2:
            return toFail(printf("Not allowed to assign to multiple arrays at once"));
        case 4:
            return toFail(printf("Not allowed for arrays"));
        case 1:
            return new Slice(find(matchValue.fields[0].Name, arraySizeMap)[0] - 1, 0);
        case 3:
            return new Slice(find(matchValue.fields[0].Name, arraySizeMap)[0] - 1, 0);
        case 5:
            return new Slice(matchValue.fields[2], matchValue.fields[3]);
        case 6:
            return toFail(printf("Shouldnt be used here"));
        default:
            return toFail(printf("Not allowed to assign to whole array"));
    }
}

export function sliceFromBitsPrimary(primary, ioAndWireToCompMap, varSizeMap, paramMap) {
    const matchValue = getPrimaryRange(primary, paramMap);
    if (matchValue == null) {
        return new Slice(find(getPrimaryName(primary), varSizeMap) - 1, 0);
    }
    else {
        return new Slice(matchValue[0], matchValue[1]);
    }
}

/**
 * Attach the merged circuits to the correct output port
 */
export function attachToOutput$0027(ioAndWireToCompMap, ioToCompMap, circuit, portName, slice, lhsType) {
    const outputOrWire = find(portName, ioAndWireToCompMap);
    const conn = createConnection(circuit.Out, item_2(0, outputOrWire.InputPorts));
    let patternInput;
    if (lhsType.tag === 1) {
        patternInput = [circuit.Comps, append(circuit.Conns, singleton(conn))];
    }
    else {
        const outputPort = find(portName, ioToCompMap);
        const conn$0027 = createConnection(item_2(0, outputOrWire.OutputPorts), item_2(0, outputPort.InputPorts));
        patternInput = [append(circuit.Comps, singleton(outputPort)), append(circuit.Conns, ofArray([conn, conn$0027]))];
    }
    return [patternInput[0], patternInput[1]];
}

/**
 * Attach the merged circuits to the correct output port
 */
export function attachToOutput(ioAndWireToCompMap, ioToCompMap, circuit, portName) {
    let outputOrWire;
    const matchValue = tryFind(portName, ioAndWireToCompMap);
    outputOrWire = ((matchValue == null) ? createComponent(ComponentType.IOLabel, portName) : matchValue);
    const conn = createConnection(circuit.Out, item_2(0, outputOrWire.InputPorts));
    let patternInput;
    const matchValue_1 = tryFind(portName, ioToCompMap);
    if (matchValue_1 != null) {
        const outputPort = matchValue_1;
        const conn$0027 = createConnection(item_2(0, outputOrWire.OutputPorts), item_2(0, outputPort.InputPorts));
        patternInput = [append(circuit.Comps, ofArray([outputOrWire, outputPort])), append(circuit.Conns, ofArray([conn, conn$0027]))];
    }
    else {
        patternInput = [append(circuit.Comps, singleton(outputOrWire)), append(circuit.Conns, singleton(conn))];
    }
    return [patternInput[0], patternInput[1]];
}

export function attachArrayToOutput(arrayToCompMap, circuitList, portName) {
    const arrayComps = find(portName, arrayToCompMap);
    return [append(arrayComps, collect((circuit) => circuit.Comps, circuitList)), fold((acc, tupledArg) => {
        const circuit_1 = tupledArg[0];
        return append(acc, append(circuit_1.Conns, singleton(createConnection(circuit_1.Out, item_2(0, tupledArg[1].InputPorts)))));
    }, empty(), zip(circuitList, arrayComps))];
}

export function concatenateCanvasStates(mainCS_, mainCS__1, newCS_, newCS__1) {
    const mainCS = [mainCS_, mainCS__1];
    const newCS = [newCS_, newCS__1];
    return [List_distinct(append(mainCS[0], newCS[0]), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), List_distinct(append(mainCS[1], newCS[1]), {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })];
}

export function dfsTraversal(graph, componentMap, connections, parents) {
    const dfsHelper = (name, tupledArg, currentNode) => {
        let bind$0040;
        const visited = tupledArg[0];
        const compMap = tupledArg[1];
        const conns = tupledArg[2];
        if (contains(currentNode, visited)) {
            return [visited, compMap, conns];
        }
        else {
            const newVisited = add(currentNode, visited);
            const neighbors = defaultArg(FSharpMap__TryFind(graph, currentNode), empty());
            const unvisitedNeighbors = filter((neighbor) => !contains(neighbor, visited), neighbors);
            const conns$0027 = fold((c, neighbor_1) => filter((conn) => !(equals(conn.Source.HostId, currentNode) && equals(conn.Target.HostId, neighbor_1)), c), conns, neighbors);
            const compMap$0027 = add_1(currentNode, (bind$0040 = find(currentNode, compMap), new Component(bind$0040.Id, bind$0040.Type, name, bind$0040.InputPorts, bind$0040.OutputPorts, bind$0040.X, bind$0040.Y, bind$0040.H, bind$0040.W, bind$0040.SymbolInfo, bind$0040.SlotInfo)), compMap);
            return fold(uncurry2(curry3(dfsHelper)(name)), [newVisited, compMap$0027, conns$0027], unvisitedNeighbors);
        }
    };
    const patternInput = fold_1((tupledArg_1, startNode) => dfsHelper(find(startNode, componentMap).Label, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]], startNode), [empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), componentMap, connections], parents);
    return [patternInput[1], patternInput[2]];
}

export function fixConsecutiveWires(oldCanvasState_, oldCanvasState__1) {
    const oldCanvasState = [oldCanvasState_, oldCanvasState__1];
    const componentMap = ofList(map_6((comp) => [comp.Id, comp], oldCanvasState[0]), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const componentIds = ofSeq(keys(componentMap), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    iterate((conn) => {
        if (!contains(conn.Source.HostId, componentIds)) {
            warn(`missing source component ${conn.Source.HostId} in a connection`);
        }
        if (!contains(conn.Target.HostId, componentIds)) {
            warn(`missing target component ${conn.Target.HostId} in a connection`);
        }
    }, oldCanvasState[1]);
    const wireConns = filter((conn_1) => {
        const src = tryFind(conn_1.Source.HostId, componentMap);
        const dst = find(conn_1.Target.HostId, componentMap);
        if (src != null) {
            if (equals(src.Type, ComponentType.IOLabel)) {
                return equals(dst.Type, ComponentType.IOLabel);
            }
            else {
                return false;
            }
        }
        else {
            return toFail(printf("source: %A, target: %A"))(conn_1.Source.HostId)(conn_1.Target.HostId);
        }
    }, oldCanvasState[1]);
    const wires = ofSeq(keys(filter_1((k, v) => equals(v.Type, ComponentType.IOLabel), componentMap)), {
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    });
    const patternInput = fold((tupledArg, conn_2) => {
        const graph = tupledArg[0];
        return [add_1(conn_2.Source.HostId, append(defaultArg(tryFind(conn_2.Source.HostId, graph), empty()), singleton(conn_2.Target.HostId)), graph), remove(conn_2.Target.HostId, tupledArg[1])];
    }, [empty_2({
        Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
    }), wires], wireConns);
    const patternInput_1 = dfsTraversal(patternInput[0], componentMap, oldCanvasState[1], patternInput[1]);
    return [ofSeq_1(FSharpMap__get_Values(patternInput_1[0])), patternInput_1[1]];
}

/**
 * Helper function to resolve conflicts in labels (must be distinct)
 * and component locations on canvas (must not overlap_)
 */
export function fixCanvasState(oldCanvasState_, oldCanvasState__1) {
    const oldCanvasState = [oldCanvasState_, oldCanvasState__1];
    const tupledArg = [mapIndexed((i, comp) => {
        let matchValue;
        return new Component(comp.Id, comp.Type, (matchValue = comp.Type, (matchValue.tag === 0) ? comp.Label : ((matchValue.tag === 1) ? comp.Label : ((comp.Label === "") ? "" : (("_" + comp.Label) + int32ToString(i))))), comp.InputPorts, comp.OutputPorts, (i + 1) * 120, (i + 1) * 120, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
    }, oldCanvasState[0]), oldCanvasState[1]];
    return fixConsecutiveWires(tupledArg[0], tupledArg[1]);
}

export function createIOComponent(item, ioType, oldMap, paramMap) {
    const ioItem_1 = (item.tag === 0) ? item.fields[0] : toFail(printf("Should not happen! Expected IOItemDU"));
    const width = getWidthFromRange(ioItem_1.Range, paramMap) | 0;
    const compType = (ioType.tag === 0) ? (new ComponentType(/* Input1 */ 0, [width, fromZero()])) : (new ComponentType(/* Output */ 1, [width]));
    return fold((map, name) => append(map, singleton([name, createComponent(compType, name)])), oldMap, ofArray(map_7((identifier) => identifier.Name, ioItem_1.Variables)));
}

/**
 * Return a Map<string,Component> for input and output ports
 * where string -> port name.
 * It is necessary in order to find components when building circuits for assignments
 */
export function getIOtoComponentMap(ioDecls, paramMap) {
    return ofList(fold((map, item) => {
        if (item.tag === 0) {
            return createIOComponent(item, item.fields[0].DeclarationType, map, paramMap);
        }
        else {
            return map;
        }
    }, empty(), ioDecls), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
}

export function isOutputComponent(comp) {
    if (comp.Type.tag === 1) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * Return a Map<string,Component> for wires
 * where string -> wire name.
 * It is necessary in order to find wire components when building circuits for assignments
 */
export function getWireToCompMap(lhs, ioAndWireToCompMap) {
    const name = getPrimaryName(lhs.PrimaryType);
    return add_1(name, createComponent(ComponentType.IOLabel, name), ioAndWireToCompMap);
}

export function collectWiresLHS(assignments) {
    return map_6((_arg_1) => {
        if (_arg_1.tag === 3) {
            return _arg_1.fields[0].Assignment.LHS;
        }
        else {
            return toFail(printf("Expected ContStatement with LHS"));
        }
    }, filter((_arg) => {
        let matchResult;
        if (_arg.tag === 3) {
            if (_arg.fields[0].StatementType.tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }, assignments));
}

export function collectInputAndWireComps(ioAndWireToCompMap) {
    return filter((comp) => {
        const matchValue = comp.Type;
        switch (matchValue.tag) {
            case 0:
            case 3:
                return true;
            default:
                return false;
        }
    }, map_6((tuple) => tuple[1], toList_1(ioAndWireToCompMap)));
}

/**
 * stores the expression along with the self determined width (MinWidth) and the contect determined Width
 */
export class ExprKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EUnary", "ENegation", "EConditionalCond", "EConditionalResult", "EShift", "EReduction", "ELogicalAnd", "ELogicalOr", "EEquality", "EComparison", "EUnaryUnsigned", "EBitwiseAnd", "EBitwiseOr", "EBitwiseXor", "EBitwiseXnor", "EAdditive", "EMultiplicative"];
    }
    static EUnary = new ExprKind(0, []);
    static ENegation = new ExprKind(1, []);
    static EConditionalCond = new ExprKind(2, []);
    static EConditionalResult = new ExprKind(3, []);
    static EShift = new ExprKind(4, []);
    static EReduction = new ExprKind(5, []);
    static ELogicalAnd = new ExprKind(6, []);
    static ELogicalOr = new ExprKind(7, []);
    static EEquality = new ExprKind(8, []);
    static EComparison = new ExprKind(9, []);
    static EUnaryUnsigned = new ExprKind(10, []);
    static EBitwiseAnd = new ExprKind(11, []);
    static EBitwiseOr = new ExprKind(12, []);
    static EBitwiseXor = new ExprKind(13, []);
    static EBitwiseXnor = new ExprKind(14, []);
    static EAdditive = new ExprKind(15, []);
    static EMultiplicative = new ExprKind(16, []);
}

export function ExprKind_$reflection() {
    return union_type("SheetCreator.ExprKind", [], ExprKind, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class UnaryKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UPrimary", "UNumber", "UParenthesis", "UConcat"];
    }
    static UPrimary = new UnaryKind(0, []);
    static UNumber = new UnaryKind(1, []);
    static UParenthesis = new UnaryKind(2, []);
    static UConcat = new UnaryKind(3, []);
}

export function UnaryKind_$reflection() {
    return union_type("SheetCreator.UnaryKind", [], UnaryKind, () => [[], [], [], []]);
}

export class ExpressionCompilable extends Record {
    constructor(Type, Operator, Head, Tail, Unary, Width) {
        super();
        this.Type = Type;
        this.Operator = Operator;
        this.Head = Head;
        this.Tail = Tail;
        this.Unary = Unary;
        this.Width = (Width | 0);
    }
}

export function ExpressionCompilable_$reflection() {
    return record_type("SheetCreator.ExpressionCompilable", [], ExpressionCompilable, () => [["Type", ExprKind_$reflection()], ["Operator", option_type(OperatorDU_$reflection())], ["Head", option_type(ExpressionCompilable_$reflection())], ["Tail", option_type(ExpressionCompilable_$reflection())], ["Unary", option_type(UnaryCompilable_$reflection())], ["Width", int32_type]]);
}

export class UnaryCompilable extends Record {
    constructor(Type, Primary, Number$, Expression, Width) {
        super();
        this.Type = Type;
        this.Primary = Primary;
        this.Number = Number$;
        this.Expression = Expression;
        this.Width = (Width | 0);
    }
}

export function UnaryCompilable_$reflection() {
    return record_type("SheetCreator.UnaryCompilable", [], UnaryCompilable, () => [["Type", UnaryKind_$reflection()], ["Primary", option_type(PrimaryDU_$reflection())], ["Number", option_type(Number$_$reflection())], ["Expression", option_type(ExpressionCompilable_$reflection())], ["Width", int32_type]]);
}

/**
 * Extract component type and name from expression (type ExpressionT)
 * Create the component using the createComponent function
 */
export function buildExpressionComponent(rhs, width) {
    let matchValue, matchValue_1;
    return createComponent((matchValue = rhs.Type, (matchValue.tag === 1) ? (new ComponentType(/* NbitsNot */ 23, [width])) : ((matchValue.tag === 12) ? (new ComponentType(/* NbitsOr */ 24, [width])) : ((matchValue.tag === 13) ? (new ComponentType(/* NbitsXor */ 21, [width, undefined])) : ((matchValue.tag === 14) ? (new ComponentType(/* NbitsXor */ 21, [width, undefined])) : ((matchValue.tag === 11) ? (new ComponentType(/* NbitsAnd */ 22, [width])) : ((matchValue.tag === 15) ? (new ComponentType(/* NbitsAdder */ 17, [width])) : ((matchValue.tag === 2) ? ComponentType.Mux2 : ((matchValue.tag === 6) ? (new ComponentType(/* GateN */ 10, ["and", 2])) : ((matchValue.tag === 7) ? (new ComponentType(/* GateN */ 10, ["or", 2])) : ((matchValue.tag === 16) ? (new ComponentType(/* NbitsXor */ 21, [width, NBitsArithmetic.Multiply])) : toFail(printf("Missing component(?) in buildExpressionComponent")))))))))))), (matchValue_1 = rhs.Type, (matchValue_1.tag === 12) ? "OR" : ((matchValue_1.tag === 13) ? "NXOR" : ((matchValue_1.tag === 14) ? "NXOR" : ((matchValue_1.tag === 15) ? "ADD" : ((matchValue_1.tag === 11) ? "AND" : ((matchValue_1.tag === 1) ? "NOT" : ((matchValue_1.tag === 2) ? "MUX" : ((matchValue_1.tag === 6) ? "G" : ((matchValue_1.tag === 7) ? "G" : ((matchValue_1.tag === 16) ? "MULT" : toFail(printf("Missing component(?) in buildExpressionComponent")))))))))))));
}

/**
 * Finds the correct component based on the name of input/wire
 * creates a circuit with that component (and if required a busSel component
 * connected to it to return the correct slice) and returns that circuit
 */
export function createPrimaryCircuit(primary, ioAndWireToCompMap, varSizeMap, paramMap) {
    const name = getPrimaryName(primary);
    const inputComp = find(name, ioAndWireToCompMap);
    const matchValue = getPrimaryRange(primary, paramMap);
    if (matchValue != null) {
        const bEnd = matchValue[1] | 0;
        const outWidth = ((matchValue[0] - bEnd) + 1) | 0;
        const busSelComp = createComponent(new ComponentType(/* BusSelection */ 6, [outWidth, bEnd]), "");
        return new Circuit(singleton(busSelComp), singleton(createConnection(item_2(0, inputComp.OutputPorts), item_2(0, busSelComp.InputPorts))), item_2(0, busSelComp.OutputPorts), outWidth);
    }
    else {
        const width = find(name, varSizeMap) | 0;
        return new Circuit(empty(), empty(), item_2(0, inputComp.OutputPorts), width);
    }
}

/**
 * Creates the correct component based on the number and returns a circuit with that component
 */
export function createNumberCircuit(number) {
    let matchValue;
    let patternInput;
    if (number.tag === 0) {
        const numBase = number.fields[1];
        const digits = number.fields[2];
        patternInput = [number.fields[0], (numBase.tag === 2) ? ("0x" + digits) : ((numBase.tag === 1) ? digits : ("0b" + digits))];
    }
    else {
        patternInput = [32, int32ToString(number.fields[0])];
    }
    const width = patternInput[0] | 0;
    const text_1 = patternInput[1];
    const constComp = createComponent(new ComponentType(/* Constant1 */ 7, [width, (matchValue = strToIntCheckWidth(width, text_1), (matchValue.tag === 1) ? toFail(printf("Shouldn\'t happen!")) : matchValue.fields[0]), text_1]), "C");
    return new Circuit(singleton(constComp), empty(), item_2(0, constComp.OutputPorts), width);
}

/**
 * Creates component for array access
 */
export function createArrayCircuit(primary, ioAndWireToCompMap, arraySizeMap, arrayCompList) {
    let matchValue, matchValue_1;
    const name = getPrimaryName(primary);
    const patternInput = (primary.tag === 2) ? toFail(printf("Arrays cannot be assigned with bit slices")) : ((primary.tag === 4) ? toFail(printf("Arrays cannot be assigned with bit slices")) : ((primary.tag === 1) ? [primary.fields[1], undefined, undefined, undefined] : ((primary.tag === 3) ? [evalExpr(primary.fields[1]), undefined, undefined, undefined] : ((primary.tag === 5) ? [(matchValue = item_3(0, primary.fields[1]), (matchValue.tag === 1) ? evalExpr(matchValue.fields[0]) : matchValue.fields[0]), primary.fields[2], primary.fields[3], undefined] : ((primary.tag === 6) ? [(matchValue_1 = item_3(0, primary.fields[1]), (matchValue_1.tag === 1) ? evalExpr(matchValue_1.fields[0]) : matchValue_1.fields[0]), undefined, undefined, primary.fields[2]] : toFail(printf("Currently entire array assignment not supported")))))));
    const vbs = patternInput[3];
    const bitsStart_1 = patternInput[1];
    const bitsEnd_1 = patternInput[2];
    const arrayReg = item_2(patternInput[0], arrayCompList);
    const patternInput_1 = find(name, arraySizeMap);
    let matchResult, bEnd, bStart, expr_2;
    if (bitsStart_1 != null) {
        if (bitsEnd_1 != null) {
            if (vbs == null) {
                matchResult = 1;
                bEnd = bitsEnd_1;
                bStart = bitsStart_1;
            }
            else {
                matchResult = 3;
            }
        }
        else {
            matchResult = 3;
        }
    }
    else if (bitsEnd_1 == null) {
        if (vbs != null) {
            matchResult = 2;
            expr_2 = vbs;
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 3;
    }
    switch (matchResult) {
        case 0:
            return new Circuit(empty(), empty(), item_2(0, arrayReg.OutputPorts), patternInput_1[0]);
        case 1: {
            const outWidth = ((bStart - bEnd) + 1) | 0;
            const busSelComp = createComponent(new ComponentType(/* BusSelection */ 6, [outWidth, bEnd]), "");
            return new Circuit(singleton(busSelComp), singleton(createConnection(item_2(0, arrayReg.OutputPorts), item_2(0, busSelComp.InputPorts))), item_2(0, busSelComp.OutputPorts), outWidth);
        }
        case 2: {
            const busSelComp_1 = createComponent(new ComponentType(/* BusSelection */ 6, [1, evalExpr(expr_2)]), "");
            return new Circuit(singleton(busSelComp_1), singleton(createConnection(item_2(0, arrayReg.OutputPorts), item_2(0, busSelComp_1.InputPorts))), item_2(0, busSelComp_1.OutputPorts), 1);
        }
        default:
            return toFail(printf("Should not happen (array access)"));
    }
}

export function getExprWidths(varSizeMap, paramMap, expr$0027) {
    const numberWidth = (number) => {
        if (number.tag === 0) {
            return number.fields[0] | 0;
        }
        else {
            return 32;
        }
    };
    const getMinWidthsExpr = (expr) => {
        switch (expr.tag) {
            case 12: {
                const unary_1 = getMinWidthsUnary(expr.fields[0]);
                return new ExpressionCompilable(ExprKind.ENegation, undefined, undefined, undefined, unary_1, unary_1.Width);
            }
            case 15: {
                const cond = getMinWidthsExpr(expr.fields[0]);
                const lhs = getMinWidthsExpr(expr.fields[1]);
                const rhs = getMinWidthsExpr(expr.fields[2]);
                const res = new ExpressionCompilable(ExprKind.EConditionalResult, undefined, lhs, rhs, undefined, max(lhs.Width, rhs.Width));
                return new ExpressionCompilable(ExprKind.EConditionalCond, undefined, cond, res, undefined, res.Width);
            }
            case 8: {
                const lhs_1 = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EShift, expr.fields[0], lhs_1, getMinWidthsExpr(expr.fields[2]), undefined, lhs_1.Width);
            }
            case 11: {
                const elem = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EReduction, expr.fields[0], undefined, undefined, new UnaryCompilable(UnaryKind.UParenthesis, undefined, undefined, elem, elem.Width), 1);
            }
            case 1:
                return new ExpressionCompilable(ExprKind.ELogicalAnd, undefined, getMinWidthsExpr(expr.fields[0]), getMinWidthsExpr(expr.fields[1]), undefined, 1);
            case 0:
                return new ExpressionCompilable(ExprKind.ELogicalOr, undefined, getMinWidthsExpr(expr.fields[0]), getMinWidthsExpr(expr.fields[1]), undefined, 1);
            case 6:
                return new ExpressionCompilable(ExprKind.EEquality, expr.fields[0], getMinWidthsExpr(expr.fields[1]), getMinWidthsExpr(expr.fields[2]), undefined, 1);
            case 7:
                return new ExpressionCompilable(ExprKind.EComparison, expr.fields[0], getMinWidthsExpr(expr.fields[1]), getMinWidthsExpr(expr.fields[2]), undefined, 1);
            case 14: {
                const n = expr.fields[0];
                const unary_3 = new UnaryCompilable(UnaryKind.UNumber, undefined, n, undefined, numberWidth(n));
                return new ExpressionCompilable(ExprKind.EUnaryUnsigned, undefined, undefined, undefined, unary_3, unary_3.Width);
            }
            case 5: {
                const lhs_6 = getMinWidthsExpr(expr.fields[0]);
                const rhs_6 = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EBitwiseAnd, undefined, lhs_6, rhs_6, undefined, max(lhs_6.Width, rhs_6.Width));
            }
            case 2: {
                const lhs_7 = getMinWidthsExpr(expr.fields[0]);
                const rhs_7 = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EBitwiseOr, undefined, lhs_7, rhs_7, undefined, max(lhs_7.Width, rhs_7.Width));
            }
            case 3: {
                const lhs_8 = getMinWidthsExpr(expr.fields[0]);
                const rhs_8 = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EBitwiseXor, undefined, lhs_8, rhs_8, undefined, max(lhs_8.Width, rhs_8.Width));
            }
            case 4: {
                const lhs_9 = getMinWidthsExpr(expr.fields[0]);
                const rhs_9 = getMinWidthsExpr(expr.fields[1]);
                return new ExpressionCompilable(ExprKind.EBitwiseXnor, undefined, lhs_9, rhs_9, undefined, max(lhs_9.Width, rhs_9.Width));
            }
            case 9: {
                const lhs_10 = getMinWidthsExpr(expr.fields[1]);
                const rhs_10 = getMinWidthsExpr(expr.fields[2]);
                return new ExpressionCompilable(ExprKind.EAdditive, expr.fields[0], lhs_10, rhs_10, undefined, max(lhs_10.Width, rhs_10.Width));
            }
            case 10: {
                const lhs_11 = getMinWidthsExpr(expr.fields[1]);
                const rhs_11 = getMinWidthsExpr(expr.fields[2]);
                return new ExpressionCompilable(ExprKind.EMultiplicative, expr.fields[0], lhs_11, rhs_11, undefined, max(lhs_11.Width, rhs_11.Width));
            }
            default: {
                const unary = getMinWidthsUnary(expr.fields[0]);
                return new ExpressionCompilable(ExprKind.EUnary, undefined, undefined, undefined, unary, unary.Width);
            }
        }
    };
    const getMinWidthsUnary = (unary_4) => {
        switch (unary_4.tag) {
            case 1: {
                const number_2 = unary_4.fields[0];
                return new UnaryCompilable(UnaryKind.UNumber, undefined, number_2, undefined, numberWidth(number_2));
            }
            case 2: {
                const expr_4 = getMinWidthsExpr(unary_4.fields[0]);
                return new UnaryCompilable(UnaryKind.UParenthesis, undefined, undefined, expr_4, expr_4.Width);
            }
            case 3: {
                const lst = getWidthsUnaryList(unary_4.fields[0]);
                return new UnaryCompilable(UnaryKind.UConcat, undefined, undefined, lst, lst.Width);
            }
            case 4: {
                const paramName_1 = unary_4.fields[0];
                const bits_1 = unary_4.fields[1];
                const value = int32ToString(find(getPrimaryName(paramName_1), paramMap));
                return new UnaryCompilable(UnaryKind.UNumber, undefined, new Number$(/* All */ 0, [parse(bits_1, 511, false, 32), BaseDU.Decimal, value, getPrimaryLocation(paramName_1)]), undefined, parse(bits_1, 511, false, 32));
            }
            default: {
                const primary = unary_4.fields[0];
                let patternInput;
                switch (primary.tag) {
                    case 5: {
                        patternInput = [(primary.fields[2] - primary.fields[3]) + 1, undefined, false];
                        break;
                    }
                    case 1: {
                        patternInput = [1, undefined, false];
                        break;
                    }
                    case 2: {
                        patternInput = [(primary.fields[1] - primary.fields[2]) + 1, undefined, false];
                        break;
                    }
                    case 4: {
                        patternInput = [primary.fields[2], getMinWidthsExpr(primary.fields[1]), false];
                        break;
                    }
                    case 3: {
                        patternInput = [1, getMinWidthsExpr(primary.fields[1]), false];
                        break;
                    }
                    case 6: {
                        patternInput = [1, getMinWidthsExpr(primary.fields[2]), false];
                        break;
                    }
                    default: {
                        const matchValue = tryFind(primary.fields[0].Name, varSizeMap);
                        patternInput = ((matchValue == null) ? [1, undefined, true] : [matchValue, undefined, false]);
                    }
                }
                if (patternInput[2]) {
                    return new UnaryCompilable(UnaryKind.UNumber, undefined, new Number$(/* Unsigned */ 1, [find(getPrimaryName(primary), paramMap), getPrimaryLocation(primary)]), undefined, 32);
                }
                else {
                    return new UnaryCompilable(UnaryKind.UPrimary, primary, undefined, patternInput[1], patternInput[0]);
                }
            }
        }
    };
    const getWidthsUnaryList = (lst_1) => {
        if (!equalsWith(equals, lst_1, defaultOf()) && (lst_1.length === 0)) {
            return new ExpressionCompilable(ExprKind.EUnary, undefined, undefined, undefined, undefined, 0);
        }
        else {
            const headExpr = getMinWidthsExpr(item_3(0, lst_1));
            const matchValue_3 = tryItem(1, lst_1);
            if (matchValue_3 == null) {
                return new ExpressionCompilable(ExprKind.EUnary, undefined, headExpr, undefined, undefined, headExpr.Width);
            }
            else {
                const tail$0027 = getWidthsUnaryList(tail_4(lst_1));
                return new ExpressionCompilable(ExprKind.EUnary, undefined, headExpr, tail$0027, undefined, headExpr.Width + tail$0027.Width);
            }
        }
    };
    return getMinWidthsExpr(expr$0027);
}

export function extendCircuit(target, circuit) {
    const widthDiff = (target - circuit.OutWidth) | 0;
    if (widthDiff < 0) {
        return toFail(printf("Target width is smaller than circuit width!"));
    }
    else if (widthDiff === 0) {
        return circuit;
    }
    else {
        const zero = createComponent(new ComponentType(/* Constant1 */ 7, [widthDiff, fromZero(), ""]), "const0");
        return joinWithMerge$0027(ofArray([circuit, new Circuit(singleton(zero), empty(), item_2(0, zero.OutputPorts), widthDiff)]));
    }
}

export function sliceCircuit(circuit, width, lsb) {
    const busSelectComp = createComponent(new ComponentType(/* BusSelection */ 6, [width, lsb]), "busSelect");
    const topCircuit = new Circuit(singleton(busSelectComp), empty(), item_2(0, busSelectComp.OutputPorts), width);
    return joinCircuits(singleton(circuit), singleton(item_2(0, busSelectComp.InputPorts)), topCircuit);
}

export function nextPowerOfTwo(value) {
    const loop = (current_mut) => {
        loop:
        while (true) {
            const current = current_mut;
            if (current >= value) {
                return current | 0;
            }
            else {
                current_mut = (current * 2);
                continue loop;
            }
            break;
        }
    };
    return loop(1) | 0;
}

export function buildMuxTreeCircuit(inputs_mut, sel_mut, outputWidth_mut) {
    buildMuxTreeCircuit:
    while (true) {
        const inputs = inputs_mut, sel = sel_mut, outputWidth = outputWidth_mut;
        if (!isEmpty(inputs)) {
            if (isEmpty(tail_3(inputs))) {
                return head_1(inputs);
            }
            else {
                const currSel = sliceCircuit(sel, 1, 0);
                let sel$0027;
                const matchValue = sel.OutWidth | 0;
                sel$0027 = ((matchValue > 1) ? sliceCircuit(sel, matchValue - 1, 1) : currSel);
                inputs_mut = map_6((_arg) => {
                    let matchResult, first, second, first_1;
                    if (!isEmpty(_arg)) {
                        if (isEmpty(tail_3(_arg))) {
                            matchResult = 1;
                            first_1 = head_1(_arg);
                        }
                        else if (isEmpty(tail_3(tail_3(_arg)))) {
                            matchResult = 0;
                            first = head_1(_arg);
                            second = head_1(tail_3(_arg));
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0: {
                            const mux = createComponent(ComponentType.Mux2, "mux2");
                            const topCircuit = new Circuit(singleton(mux), empty(), item_2(0, mux.OutputPorts), outputWidth);
                            return joinCircuits(ofArray([second, first, currSel]), ofArray([item_2(1, mux.InputPorts), item_2(0, mux.InputPorts), item_2(2, mux.InputPorts)]), topCircuit);
                        }
                        case 1:
                            return first_1;
                        default:
                            return toFail(printf("Invalid mux tree input list"));
                    }
                }, chunkBySize(2, inputs));
                sel_mut = sel$0027;
                outputWidth_mut = outputWidth;
                continue buildMuxTreeCircuit;
            }
        }
        else {
            return toFail(printf("Mux tree requires at least one input"));
        }
        break;
    }
}

export function buildFixedShiftCircuit(inputCircuit, shiftNo, shiftType) {
    if (shiftNo === 0) {
        return inputCircuit;
    }
    else if (shiftNo < inputCircuit.OutWidth) {
        const busSelComp = (shiftType.tag === 0) ? createComponent(new ComponentType(/* BusSelection */ 6, [inputCircuit.OutWidth - shiftNo, 0]), "") : createComponent(new ComponentType(/* BusSelection */ 6, [inputCircuit.OutWidth - shiftNo, shiftNo]), "");
        const busSelCircuit = new Circuit(singleton(busSelComp), empty(), item_2(0, busSelComp.OutputPorts), inputCircuit.OutWidth - shiftNo);
        const selectedCircuit = joinCircuits(singleton(inputCircuit), singleton(item_2(0, busSelComp.InputPorts)), busSelCircuit);
        let paddingCircuit;
        switch (shiftType.tag) {
            case 2: {
                const msbCircuit = sliceCircuit(inputCircuit, 1, inputCircuit.OutWidth - 1);
                const spreaderComp = createComponent(new ComponentType(/* NbitSpreader */ 25, [shiftNo]), "SPREAD");
                const spreaderCircuit = new Circuit(singleton(spreaderComp), empty(), item_2(0, spreaderComp.OutputPorts), shiftNo);
                paddingCircuit = joinCircuits(singleton(msbCircuit), singleton(item_2(0, spreaderComp.InputPorts)), spreaderCircuit);
                break;
            }
            default:
                paddingCircuit = createNumberCircuit(new Number$(/* All */ 0, [shiftNo, BaseDU.Binary, "0", 100]));
        }
        if (shiftType.tag === 0) {
            return joinWithMerge$0027(ofArray([paddingCircuit, selectedCircuit]));
        }
        else {
            return joinWithMerge$0027(ofArray([selectedCircuit, paddingCircuit]));
        }
    }
    else if (shiftType.tag === 2) {
        const msbCircuit_1 = sliceCircuit(inputCircuit, 1, inputCircuit.OutWidth - 1);
        const spreaderComp_1 = createComponent(new ComponentType(/* NbitSpreader */ 25, [inputCircuit.OutWidth]), "SPREAD");
        const spreaderCircuit_1 = new Circuit(singleton(spreaderComp_1), empty(), item_2(0, spreaderComp_1.OutputPorts), inputCircuit.OutWidth);
        return joinCircuits(singleton(msbCircuit_1), singleton(item_2(0, spreaderComp_1.InputPorts)), spreaderCircuit_1);
    }
    else {
        return createNumberCircuit(new Number$(/* All */ 0, [inputCircuit.OutWidth, BaseDU.Binary, "0", 100]));
    }
}

/**
 * The main circuit creation function called with the RHS of an assignment as a parameter
 * Contains 6 recursive functions which eventually build the whole RHS expression
 * The starting point is the buildExpressionCircuit rec function
 * target is 0 if there is no lhs
 */
export function mainExpressionCircuitBuilder(expr, ioAndWireToCompMap, varSizeMap, paramMap, target, arraySizeMap, arrayToCompMap) {
    const buildExpressionCircuit = (expr_1) => ((targetWidth) => {
        const matchValue = expr_1.Type;
        let matchResult;
        switch (matchValue.tag) {
            case 0: {
                matchResult = 0;
                break;
            }
            case 1: {
                matchResult = 1;
                break;
            }
            case 2: {
                matchResult = 2;
                break;
            }
            case 5: {
                matchResult = 5;
                break;
            }
            case 6:
            case 7: {
                matchResult = 6;
                break;
            }
            case 8: {
                matchResult = 7;
                break;
            }
            case 9: {
                matchResult = 8;
                break;
            }
            case 4: {
                if (equals(value_1(expr_1.Tail).Type, ExprKind.EUnaryUnsigned)) {
                    matchResult = 3;
                }
                else {
                    matchResult = 4;
                }
                break;
            }
            default:
                matchResult = 9;
        }
        switch (matchResult) {
            case 0:
                return extendCircuit(targetWidth, buildUnaryCircuit(value_1(expr_1.Unary))(targetWidth));
            case 1: {
                const c1 = extendCircuit(targetWidth, buildUnaryCircuit(value_1(expr_1.Unary))(targetWidth));
                const topComp = buildExpressionComponent(expr_1, c1.OutWidth);
                const topCircuit = new Circuit(singleton(topComp), empty(), item_2(0, topComp.OutputPorts), c1.OutWidth);
                return joinCircuits(singleton(c1), singleton(item_2(0, topComp.InputPorts)), topCircuit);
            }
            case 2: {
                const c3 = buildExpressionCircuit(value_1(expr_1.Head))(value_1(expr_1.Head).Width);
                const patternInput = buildConditionalCircuit(value_1(expr_1.Tail))(targetWidth);
                const c1_1 = patternInput[0];
                const topComp_1 = buildExpressionComponent(expr_1, c1_1.OutWidth);
                const topCircuit_1 = new Circuit(singleton(topComp_1), empty(), item_2(0, topComp_1.OutputPorts), c1_1.OutWidth);
                return joinCircuits(ofArray([patternInput[1], c1_1, c3]), ofArray([item_2(0, topComp_1.InputPorts), item_2(1, topComp_1.InputPorts), item_2(2, topComp_1.InputPorts)]), topCircuit_1);
            }
            case 3:
                return buildShiftCircuit(expr_1)(targetWidth);
            case 4:
                return buildVariableShiftCircuit(expr_1)(targetWidth);
            case 5:
                return buildReductionAndLogicalCircuit(expr_1)("reduction")(targetWidth);
            case 6: {
                const c1_2 = buildReductionAndLogicalCircuit(value_1(expr_1.Head))("logical")(max(value_1(expr_1.Head).Width, value_1(expr_1.Tail).Width));
                const c2_1 = buildReductionAndLogicalCircuit(value_1(expr_1.Tail))("logical")(max(value_1(expr_1.Head).Width, value_1(expr_1.Tail).Width));
                const topComp_2 = buildExpressionComponent(expr_1, c1_2.OutWidth);
                const topCircuit_2 = new Circuit(singleton(topComp_2), empty(), item_2(0, topComp_2.OutputPorts), c1_2.OutWidth);
                return joinCircuits(ofArray([c1_2, c2_1]), ofArray([item_2(0, topComp_2.InputPorts), item_2(1, topComp_2.InputPorts)]), topCircuit_2);
            }
            case 7:
                return buildEqualityCircuit(expr_1);
            case 8:
                return buildComparisonCircuit(expr_1);
            default: {
                const c1_3 = extendCircuit(targetWidth, buildExpressionCircuit(value_1(expr_1.Head))(targetWidth));
                const c2_2 = extendCircuit(targetWidth, buildExpressionCircuit(value_1(expr_1.Tail))(targetWidth));
                const topComp_3 = buildExpressionComponent(expr_1, c1_3.OutWidth);
                if (expr_1.Type.tag === 15) {
                    let patternInput_1;
                    const matchValue_2 = expr_1.Operator;
                    let matchResult_1;
                    if (matchValue_2 != null) {
                        switch (matchValue_2.tag) {
                            case 14: {
                                matchResult_1 = 0;
                                break;
                            }
                            case 15: {
                                matchResult_1 = 1;
                                break;
                            }
                            default:
                                matchResult_1 = 2;
                        }
                    }
                    else {
                        matchResult_1 = 2;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            patternInput_1 = [c2_2, createNumberCircuit(new Number$(/* All */ 0, [1, BaseDU.Binary, "0", 100]))];
                            break;
                        }
                        case 1: {
                            const cinCircuit = createNumberCircuit(new Number$(/* All */ 0, [1, BaseDU.Binary, "1", 100]));
                            const nBitsNotComp = createComponent(new ComponentType(/* NbitsNot */ 23, [c2_2.OutWidth]), "NOT");
                            const nBitsNotCircuit = new Circuit(singleton(nBitsNotComp), empty(), item_2(0, nBitsNotComp.OutputPorts), c2_2.OutWidth);
                            patternInput_1 = [joinCircuits(singleton(c2_2), singleton(item_2(0, nBitsNotComp.InputPorts)), nBitsNotCircuit), cinCircuit];
                            break;
                        }
                        default:
                            patternInput_1 = toFail(printf("Can\'t happen"));
                    }
                    const ioLabelComp = createComponent(new ComponentType(/* Viewer */ 2, [1]), "Adder_Cout");
                    const topCircuit_3 = new Circuit(ofArray([topComp_3, ioLabelComp]), singleton(createConnection(item_2(1, topComp_3.OutputPorts), item_2(0, ioLabelComp.InputPorts))), item_2(0, topComp_3.OutputPorts), c1_3.OutWidth);
                    return joinCircuits(ofArray([patternInput_1[1], c1_3, patternInput_1[0]]), ofArray([item_2(0, topComp_3.InputPorts), item_2(1, topComp_3.InputPorts), item_2(2, topComp_3.InputPorts)]), topCircuit_3);
                }
                else {
                    const topCircuit_4 = new Circuit(singleton(topComp_3), empty(), item_2(0, topComp_3.OutputPorts), c1_3.OutWidth);
                    const gateCircuit = joinCircuits(ofArray([c1_3, c2_2]), ofArray([item_2(0, topComp_3.InputPorts), item_2(1, topComp_3.InputPorts)]), topCircuit_4);
                    if (expr_1.Type.tag === 14) {
                        const notComp = createComponent(new ComponentType(/* NbitsNot */ 23, [gateCircuit.OutWidth]), "NOT");
                        const notCircuit = new Circuit(singleton(notComp), empty(), item_2(0, notComp.OutputPorts), gateCircuit.OutWidth);
                        return joinCircuits(singleton(gateCircuit), singleton(item_2(0, notComp.InputPorts)), notCircuit);
                    }
                    else {
                        return gateCircuit;
                    }
                }
            }
        }
    });
    const buildUnaryCircuit = (unary) => ((targetWidth_1) => {
        const matchValue_4 = unary.Type;
        switch (matchValue_4.tag) {
            case 1:
                return createNumberCircuit(value_1(unary.Number));
            case 2:
                return extendCircuit(targetWidth_1, buildExpressionCircuit(value_1(unary.Expression))(targetWidth_1));
            case 3:
                return buildUnaryListCircuit(value_1(unary.Expression));
            default: {
                const primaryName = getPrimaryName(value_1(unary.Primary));
                getPrimaryLocation(value_1(unary.Primary));
                const matchValue_5 = tryFind(primaryName, arrayToCompMap);
                if (matchValue_5 == null) {
                    const matchValue_6 = unary.Primary;
                    const matchValue_7 = unary.Expression;
                    let matchResult_2, expr_2, id;
                    if (matchValue_6 != null) {
                        if (matchValue_6.tag === 3) {
                            if (matchValue_7 != null) {
                                matchResult_2 = 0;
                                expr_2 = matchValue_7;
                                id = matchValue_6.fields[0];
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0: {
                            buildExpressionCircuit(expr_2)(expr_2.Width);
                            const primaryComp = find(id.Name, ioAndWireToCompMap);
                            const primaryWidth = find(id.Name, varSizeMap) | 0;
                            new Circuit(empty(), empty(), item_2(0, primaryComp.OutputPorts), primaryWidth);
                            const index_1 = buildExpressionCircuit(expr_2)(expr_2.Width);
                            const primaryComp_1 = find(id.Name, ioAndWireToCompMap);
                            const shiftLeft = createComponent(new ComponentType(/* Shift */ 46, [primaryWidth, expr_2.Width, ShiftComponentType.LSL]), "sll");
                            const topCircuit_5 = new Circuit(singleton(shiftLeft), empty(), item_2(0, shiftLeft.OutputPorts), primaryWidth);
                            const const1 = createComponent(new ComponentType(/* Constant1 */ 7, [primaryWidth, op_Subtraction(op_LeftShift(fromOne(), primaryWidth), fromOne()), ""]), "const1");
                            const shiftLeftIthCircuit = joinCircuits(ofArray([new Circuit(singleton(const1), empty(), item_2(0, const1.OutputPorts), primaryWidth), index_1]), ofArray([item_2(0, shiftLeft.InputPorts), item_2(1, shiftLeft.InputPorts)]), topCircuit_5);
                            const primaryCircuit_1 = new Circuit(empty(), empty(), item_2(0, primaryComp_1.OutputPorts), primaryWidth);
                            const andComp = createComponent(new ComponentType(/* NbitsAnd */ 22, [primaryWidth]), "and");
                            const andCircuit = new Circuit(singleton(andComp), empty(), item_2(0, andComp.OutputPorts), primaryWidth);
                            const andCircuit_1 = joinCircuits(ofArray([primaryCircuit_1, shiftLeftIthCircuit]), ofArray([item_2(0, andComp.InputPorts), item_2(1, andComp.InputPorts)]), andCircuit);
                            const shiftRight = createComponent(new ComponentType(/* Shift */ 46, [primaryWidth, expr_2.Width, ShiftComponentType.LSR]), "srl");
                            const sllCircuit = new Circuit(singleton(shiftRight), empty(), item_2(0, shiftRight.OutputPorts), primaryWidth);
                            return sliceCircuit(joinCircuits(ofArray([andCircuit_1, index_1]), ofArray([item_2(0, shiftRight.InputPorts), item_2(1, shiftRight.InputPorts)]), sllCircuit), primaryWidth, 0);
                        }
                        default:
                            return createPrimaryCircuit(value_1(unary.Primary), ioAndWireToCompMap, varSizeMap, paramMap);
                    }
                }
                else {
                    const compList = matchValue_5;
                    return createArrayCircuit(value_1(unary.Primary), ioAndWireToCompMap, arraySizeMap, compList);
                }
            }
        }
    });
    const buildUnaryListCircuit = (unaryList) => {
        const head = buildExpressionCircuit(value_1(unaryList.Head))(value_1(unaryList.Head).Width);
        return joinWithMerge$0027(reverse((unaryList.Tail != null) ? append(singleton(head), singleton(buildUnaryListCircuit(value_1(unaryList.Tail)))) : singleton(head)));
    };
    const buildConditionalCircuit = (tail_1) => ((targetWidth_2) => [extendCircuit(targetWidth_2, buildExpressionCircuit(value_1(tail_1.Head))(targetWidth_2)), extendCircuit(targetWidth_2, buildExpressionCircuit(value_1(tail_1.Tail))(targetWidth_2))]);
    const buildVariableShiftCircuit = (expr_3) => ((targetWidth_3) => {
        let matchValue_10;
        const c1_5 = extendCircuit(targetWidth_3, buildExpressionCircuit(value_1(expr_3.Head))(targetWidth_3));
        const c2_4 = buildExpressionCircuit(value_1(expr_3.Tail))(value_1(expr_3.Tail).Width);
        const topComp_4 = createComponent(new ComponentType(/* Shift */ 46, [c1_5.OutWidth, c2_4.OutWidth, (matchValue_10 = value_1(expr_3.Operator), (matchValue_10.tag === 17) ? ShiftComponentType.LSL : ((matchValue_10.tag === 19) ? ShiftComponentType.ASR : ShiftComponentType.LSR))]), "SHIFT");
        const topCircuit_6 = new Circuit(singleton(topComp_4), empty(), item_2(0, topComp_4.OutputPorts), c1_5.OutWidth);
        return joinCircuits(ofArray([c1_5, c2_4]), ofArray([item_2(0, topComp_4.InputPorts), item_2(1, topComp_4.InputPorts)]), topCircuit_6);
    });
    const buildShiftCircuit = (expr_4) => ((targetWidth_4) => {
        const operator = value_1(expr_4.Operator);
        const number = value_1(value_1(value_1(expr_4.Tail).Unary).Number);
        const shiftNo = ((number.tag === 0) ? parse(number.fields[2], 511, false, 32) : number.fields[0]) | 0;
        const c1_6 = extendCircuit(targetWidth_4, buildExpressionCircuit(value_1(expr_4.Head))(targetWidth_4));
        if (shiftNo < c1_6.OutWidth) {
            const busSelComp = (operator.tag === 17) ? createComponent(new ComponentType(/* BusSelection */ 6, [c1_6.OutWidth - shiftNo, 0]), "") : createComponent(new ComponentType(/* BusSelection */ 6, [c1_6.OutWidth - shiftNo, shiftNo]), "");
            const busSelCircuit = new Circuit(singleton(busSelComp), empty(), item_2(0, busSelComp.OutputPorts), c1_6.OutWidth - shiftNo);
            const selectedCircuit = joinCircuits(singleton(c1_6), singleton(item_2(0, busSelComp.InputPorts)), busSelCircuit);
            let constantCircuit;
            switch (operator.tag) {
                case 18:
                case 17: {
                    constantCircuit = createNumberCircuit(new Number$(/* All */ 0, [shiftNo, BaseDU.Binary, "0", 100]));
                    break;
                }
                default: {
                    const msbSelComp = createComponent(new ComponentType(/* BusSelection */ 6, [1, c1_6.OutWidth - 1]), "");
                    const msbSelCircuit = new Circuit(singleton(msbSelComp), empty(), item_2(0, msbSelComp.OutputPorts), 1);
                    const msbCircuit = joinCircuits(singleton(c1_6), singleton(item_2(0, msbSelComp.InputPorts)), msbSelCircuit);
                    const spreaderComp = createComponent(new ComponentType(/* NbitSpreader */ 25, [shiftNo]), "SPREAD");
                    const spreaderCircuit = new Circuit(singleton(spreaderComp), empty(), item_2(0, spreaderComp.OutputPorts), shiftNo);
                    constantCircuit = joinCircuits(singleton(msbCircuit), singleton(item_2(0, spreaderComp.InputPorts)), spreaderCircuit);
                }
            }
            return joinWithMerge$0027((operator.tag === 17) ? ofArray([constantCircuit, selectedCircuit]) : ofArray([selectedCircuit, constantCircuit]));
        }
        else {
            return createNumberCircuit(new Number$(/* All */ 0, [c1_6.OutWidth, BaseDU.Binary, "0", 100]));
        }
    });
    const buildReductionAndLogicalCircuit = (expr_5) => ((circType) => ((targetWidth_5) => {
        const c1_7 = (circType === "reduction") ? buildUnaryCircuit(value_1(expr_5.Unary))(value_1(expr_5.Unary).Width) : ((circType === "logical") ? extendCircuit(targetWidth_5, buildExpressionCircuit(expr_5)(targetWidth_5)) : toFail(printf("Calling buildReductionAndLogicalCircuit with undefined circType")));
        let busCompareComp;
        const matchValue_11 = expr_5.Operator;
        let matchResult_3;
        if (circType === "reduction") {
            if (matchValue_11 != null) {
                switch (matchValue_11.tag) {
                    case 5:
                    case 6: {
                        matchResult_3 = 0;
                        break;
                    }
                    default:
                        matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
        }
        else {
            matchResult_3 = 1;
        }
        switch (matchResult_3) {
            case 0: {
                busCompareComp = createComponent(new ComponentType(/* BusCompare */ 47, [c1_7.OutWidth, op_Subtraction(op_LeftShift(fromOne(), c1_7.OutWidth), fromOne())]), "COMP");
                break;
            }
            default:
                busCompareComp = createComponent(new ComponentType(/* BusCompare */ 47, [c1_7.OutWidth, fromZero()]), "COMP");
        }
        const busCompareCircuit = new Circuit(singleton(busCompareComp), empty(), item_2(0, busCompareComp.OutputPorts), 1);
        const matchValue_13 = expr_5.Operator;
        let matchResult_4;
        if (circType === "reduction") {
            if (matchValue_13 != null) {
                switch (matchValue_13.tag) {
                    case 5:
                    case 20:
                    case 7: {
                        matchResult_4 = 0;
                        break;
                    }
                    default:
                        matchResult_4 = 1;
                }
            }
            else {
                matchResult_4 = 1;
            }
        }
        else {
            matchResult_4 = 1;
        }
        switch (matchResult_4) {
            case 0:
                return joinCircuits(singleton(c1_7), singleton(item_2(0, busCompareComp.InputPorts)), busCompareCircuit);
            default: {
                const comparedCircuit = joinCircuits(singleton(c1_7), singleton(item_2(0, busCompareComp.InputPorts)), busCompareCircuit);
                const notGateComp = createComponent(ComponentType.Not, "G");
                const notGateCircuit = new Circuit(singleton(notGateComp), empty(), item_2(0, notGateComp.OutputPorts), 1);
                return joinCircuits(singleton(comparedCircuit), singleton(item_2(0, notGateComp.InputPorts)), notGateCircuit);
            }
        }
    }));
    const buildEqualityCircuit = (expr_6) => {
        const targetWidth_6 = max(value_1(expr_6.Head).Width, value_1(expr_6.Tail).Width) | 0;
        const c1_8 = extendCircuit(targetWidth_6, buildExpressionCircuit(value_1(expr_6.Head))(targetWidth_6));
        const c2_5 = extendCircuit(targetWidth_6, buildExpressionCircuit(value_1(expr_6.Tail))(targetWidth_6));
        const xorComp = createComponent(new ComponentType(/* NbitsXor */ 21, [c1_8.OutWidth, undefined]), "xor");
        const xorCircuit = new Circuit(singleton(xorComp), empty(), item_2(0, xorComp.OutputPorts), c1_8.OutWidth);
        const xorCircuit$0027 = joinCircuits(ofArray([c1_8, c2_5]), ofArray([item_2(0, xorComp.InputPorts), item_2(1, xorComp.InputPorts)]), xorCircuit);
        const busCompare = createComponent(new ComponentType(/* BusCompare */ 47, [c1_8.OutWidth, fromZero()]), "COMP");
        const compCircuit = new Circuit(singleton(busCompare), empty(), item_2(0, busCompare.OutputPorts), 1);
        const comparedCircuit_1 = joinCircuits(singleton(xorCircuit$0027), singleton(item_2(0, busCompare.InputPorts)), compCircuit);
        const matchValue_15 = expr_6.Operator;
        let matchResult_5;
        if (matchValue_15 != null) {
            switch (matchValue_15.tag) {
                case 9: {
                    matchResult_5 = 0;
                    break;
                }
                case 8: {
                    matchResult_5 = 1;
                    break;
                }
                default:
                    matchResult_5 = 2;
            }
        }
        else {
            matchResult_5 = 2;
        }
        switch (matchResult_5) {
            case 0: {
                const notGateComp_1 = createComponent(ComponentType.Not, "NOT");
                const notGateCircuit_1 = new Circuit(singleton(notGateComp_1), empty(), item_2(0, notGateComp_1.OutputPorts), 1);
                return joinCircuits(singleton(comparedCircuit_1), singleton(item_2(0, notGateComp_1.InputPorts)), notGateCircuit_1);
            }
            case 1:
                return comparedCircuit_1;
            default:
                return toFail(printf("Invalid operator in equality expression"));
        }
    };
    const buildComparisonCircuit = (expr_7) => {
        let patternInput_2, cinCircuit_1, nBitsNotComp_1, nBitsNotCircuit_1, ioLabelComp_1, topCircuit_7;
        const targetWidth_7 = max(value_1(expr_7.Head).Width, value_1(expr_7.Tail).Width) | 0;
        const c1_9 = extendCircuit(targetWidth_7 + 1, buildExpressionCircuit(value_1(expr_7.Head))(targetWidth_7));
        const c2_6 = extendCircuit(targetWidth_7 + 1, buildExpressionCircuit(value_1(expr_7.Tail))(targetWidth_7));
        const addComp = createComponent(new ComponentType(/* NbitsAdder */ 17, [targetWidth_7 + 1]), "Add");
        const MSB = sliceCircuit((patternInput_2 = ((cinCircuit_1 = createNumberCircuit(new Number$(/* All */ 0, [1, BaseDU.Binary, "1", 100])), (nBitsNotComp_1 = createComponent(new ComponentType(/* NbitsNot */ 23, [c2_6.OutWidth]), "NOT"), (nBitsNotCircuit_1 = (new Circuit(singleton(nBitsNotComp_1), empty(), item_2(0, nBitsNotComp_1.OutputPorts), c2_6.OutWidth)), [joinCircuits(singleton(c2_6), singleton(item_2(0, nBitsNotComp_1.InputPorts)), nBitsNotCircuit_1), cinCircuit_1])))), (ioLabelComp_1 = createComponent(new ComponentType(/* Viewer */ 2, [1]), "Adder_Cout"), (topCircuit_7 = (new Circuit(ofArray([addComp, ioLabelComp_1]), singleton(createConnection(item_2(1, addComp.OutputPorts), item_2(0, ioLabelComp_1.InputPorts))), item_2(0, addComp.OutputPorts), c1_9.OutWidth)), joinCircuits(ofArray([patternInput_2[1], c1_9, patternInput_2[0]]), ofArray([item_2(0, addComp.InputPorts), item_2(1, addComp.InputPorts), item_2(2, addComp.InputPorts)]), topCircuit_7)))), 1, targetWidth_7);
        let busCompare_1;
        const matchValue_16 = expr_7.Operator;
        let matchResult_6;
        if (matchValue_16 != null) {
            switch (matchValue_16.tag) {
                case 11:
                case 12: {
                    matchResult_6 = 0;
                    break;
                }
                case 13:
                case 10: {
                    matchResult_6 = 1;
                    break;
                }
                default:
                    matchResult_6 = 2;
            }
        }
        else {
            matchResult_6 = 2;
        }
        switch (matchResult_6) {
            case 0: {
                busCompare_1 = createComponent(new ComponentType(/* BusCompare */ 47, [1, fromZero()]), "COMP");
                break;
            }
            case 1: {
                busCompare_1 = createComponent(new ComponentType(/* BusCompare */ 47, [1, fromOne()]), "COMP");
                break;
            }
            default:
                busCompare_1 = toFail(printf("Invalid comparison operator!"));
        }
        const busCompareCircuit_1 = new Circuit(singleton(busCompare_1), empty(), item_2(0, busCompare_1.OutputPorts), 1);
        const compareCircuit = joinCircuits(singleton(MSB), singleton(item_2(0, busCompare_1.InputPorts)), busCompareCircuit_1);
        const matchValue_17 = expr_7.Operator;
        let matchResult_7;
        if (matchValue_17 != null) {
            switch (matchValue_17.tag) {
                case 11:
                case 13: {
                    matchResult_7 = 0;
                    break;
                }
                default:
                    matchResult_7 = 1;
            }
        }
        else {
            matchResult_7 = 1;
        }
        switch (matchResult_7) {
            case 0: {
                const notGateComp_2 = createComponent(ComponentType.Not, "NOT");
                const notGateCircuit_2 = new Circuit(singleton(notGateComp_2), empty(), item_2(0, notGateComp_2.OutputPorts), 1);
                return joinCircuits(singleton(compareCircuit), singleton(item_2(0, notGateComp_2.InputPorts)), notGateCircuit_2);
            }
            default:
                return compareCircuit;
        }
    };
    const exprWidths = getExprWidths(varSizeMap, paramMap, expr);
    return buildExpressionCircuit(exprWidths)(max(target, exprWidths.Width));
}

export function getCombinationalVars(ast, project) {
    return List_distinct(append(map_6((assign) => getPrimaryName(assign.LHS.PrimaryType), foldAST(getContAssignments, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), append(map_6((assign_1) => getPrimaryName(assign_1.LHS.PrimaryType), foldAST(getBlockingAssignments, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), map_6(getPrimaryName, collect((modInst) => getModuleInstantiationOutputPrimaries(modInst, project), foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))))), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
}

export function getClockedVars(ast) {
    return List_distinct(map_6((tupledArg) => getPrimaryName(tupledArg[0].LHS.PrimaryType), foldAST(getNonBlockingAssignmentsWithLocation, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
}

export function overlaps(slice1, slice2) {
    return max(slice1.LSB, slice2.LSB) <= min(slice1.MSB, slice2.MSB);
}

/**
 * debug:
 */
export function isCircuitValid(circuit, varToCompMap) {
    const inputPorts = map_6((port) => port.Id, collect((comp) => comp.InputPorts, append(circuit.Comps, MapModule_ValuesL(varToCompMap))));
    const outputPorts = map_6((port_1) => port_1.Id, collect((comp_1) => comp_1.OutputPorts, append(circuit.Comps, MapModule_ValuesL(varToCompMap))));
    if (isEmpty(filter((conn) => !(contains_1(conn.Source.Id, outputPorts, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }) && contains_1(conn.Target.Id, inputPorts, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })), circuit.Conns))) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * Helper function to see if an array is written to multiple times - determines whether it synthesises to a memory or registers
 */
export function createRegisterArray(var$, arraySizeMap) {
    const patternInput = find(var$, arraySizeMap);
    return toList(delay(() => map_8((i) => createComponent(new ComponentType(/* Register */ 33, [patternInput[0]]), toText(printf("%s_reg_%d"))(var$)(i)), rangeDouble(0, 1, item_3(0, patternInput[1]) - 1))));
}

export function mergeIfElse(lst1, lst2, varToCompMap) {
    let width_2;
    if (!isEmpty(lst1)) {
        if (!isEmpty(lst2)) {
            if (equals(head_1(lst1).Slice, head_1(lst2).Slice)) {
                return append(singleton([head_1(lst1), head_1(lst2)]), mergeIfElse(tail_3(lst1), tail_3(lst2), varToCompMap));
            }
            else if (overlaps(head_1(lst1).Slice, head_1(lst2).Slice)) {
                const start1 = head_1(lst1).Slice.LSB | 0;
                const end1 = head_1(lst1).Slice.MSB | 0;
                const start2 = head_1(lst2).Slice.LSB | 0;
                const end2 = head_1(lst2).Slice.MSB | 0;
                const minEnd = min(end1, end2) | 0;
                const maxStart = max(start1, start2) | 0;
                return ofArray([(start1 < maxStart) ? [new BitMapping(new Slice(maxStart - 1, start1), sliceCircuit(head_1(lst1).Circuit, maxStart - start1, 0), head_1(lst1).LHSType), undefined] : ((start2 < maxStart) ? [undefined, new BitMapping(new Slice(maxStart - 1, start2), sliceCircuit(head_1(lst2).Circuit, maxStart - start2, 0), head_1(lst2).LHSType)] : [undefined, undefined]), (width_2 = (((minEnd - maxStart) + 1) | 0), [new BitMapping(new Slice(minEnd, maxStart), sliceCircuit(head_1(lst1).Circuit, width_2, maxStart - start1), head_1(lst1).LHSType), new BitMapping(new Slice(minEnd, maxStart), sliceCircuit(head_1(lst2).Circuit, width_2, maxStart - start2), head_1(lst2).LHSType)]), (end1 > minEnd) ? [new BitMapping(new Slice(end1, minEnd + 1), sliceCircuit(head_1(lst1).Circuit, end1 - minEnd, (minEnd - start1) + 1), head_1(lst1).LHSType), undefined] : ((end2 > minEnd) ? [undefined, new BitMapping(new Slice(end2, minEnd + 1), sliceCircuit(head_1(lst2).Circuit, end2 - minEnd, (minEnd - start2) + 1), head_1(lst2).LHSType)] : [undefined, undefined])]);
            }
            else if (compare(head_1(lst1).Slice, head_1(lst2).Slice) < 0) {
                return append(singleton([head_1(lst1), undefined]), mergeIfElse(tail_3(lst1), lst2, varToCompMap));
            }
            else {
                return append(singleton([undefined, head_1(lst2)]), mergeIfElse(lst1, tail_3(lst2), varToCompMap));
            }
        }
        else {
            return append(singleton([head_1(lst1), undefined]), mergeIfElse(tail_3(lst1), empty(), varToCompMap));
        }
    }
    else if (!isEmpty(lst2)) {
        return append(singleton([head_1(lst2), undefined]), mergeIfElse(tail_3(lst2), empty(), varToCompMap));
    }
    else {
        return empty();
    }
}

export function addAssignment(assignment, bits, varToCompMap) {
    const overlapping = filter((bitmapping) => overlaps(assignment.Slice, bitmapping.Slice), bits);
    if (isEmpty(overlapping)) {
        return sortBy((mapping) => mapping.Slice, append(bits, singleton(assignment)), {
            Compare: (x, y) => (compare(x, y) | 0),
        });
    }
    else {
        const first = head_1(overlapping);
        const last = last_1(overlapping);
        const matchValue = assignment.Slice.LSB <= first.Slice.LSB;
        const matchValue_1 = assignment.Slice.MSB >= last.Slice.MSB;
        if (matchValue) {
            if (matchValue_1) {
                return sortBy((mapping_2) => mapping_2.Slice, append(singleton(assignment), filter((mapping_1) => !overlaps(assignment.Slice, mapping_1.Slice), bits)), {
                    Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
                });
            }
            else {
                const width_1 = (last.Slice.MSB - assignment.Slice.MSB) | 0;
                const newLastLSB = ((last.Slice.MSB - width_1) + 1) | 0;
                const busSelectComp_1 = createComponent(new ComponentType(/* BusSelection */ 6, [width_1, (assignment.Slice.MSB - last.Slice.LSB) + 1]), "busSelect");
                const topCircuit_1 = new Circuit(singleton(busSelectComp_1), empty(), item_2(0, busSelectComp_1.OutputPorts), width_1);
                return sortBy((mapping_6) => mapping_6.Slice, append(ofArray([new BitMapping(new Slice(last.Slice.MSB, newLastLSB), joinCircuits(singleton(last.Circuit), singleton(item_2(0, busSelectComp_1.InputPorts)), topCircuit_1), last.LHSType), assignment]), filter((mapping_5) => !overlaps(assignment.Slice, mapping_5.Slice), bits)), {
                    Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
                });
            }
        }
        else if (matchValue_1) {
            const width = (assignment.Slice.LSB - first.Slice.LSB) | 0;
            const newFirstMSB = ((first.Slice.LSB + width) - 1) | 0;
            const busSelectComp = createComponent(new ComponentType(/* BusSelection */ 6, [width, 0]), "busSelect");
            const topCircuit = new Circuit(singleton(busSelectComp), empty(), item_2(0, busSelectComp.OutputPorts), width);
            return sortBy((mapping_4) => mapping_4.Slice, append(ofArray([new BitMapping(new Slice(newFirstMSB, first.Slice.LSB), joinCircuits(singleton(first.Circuit), singleton(item_2(0, busSelectComp.InputPorts)), topCircuit), first.LHSType), assignment]), filter((mapping_3) => !overlaps(assignment.Slice, mapping_3.Slice), bits)), {
                Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
            });
        }
        else {
            const width_2 = (assignment.Slice.LSB - first.Slice.LSB) | 0;
            const newFirstMSB_1 = ((first.Slice.LSB + width_2) - 1) | 0;
            const busSelectComp_2 = createComponent(new ComponentType(/* BusSelection */ 6, [width_2, 0]), "busSelect");
            const topCircuit_2 = new Circuit(singleton(busSelectComp_2), empty(), item_2(0, busSelectComp_2.OutputPorts), width_2);
            const newFirst_1 = new BitMapping(new Slice(newFirstMSB_1, first.Slice.LSB), joinCircuits(singleton(first.Circuit), singleton(item_2(0, busSelectComp_2.InputPorts)), topCircuit_2), first.LHSType);
            const width_3 = (last.Slice.MSB - assignment.Slice.MSB) | 0;
            const newLastLSB_1 = ((last.Slice.MSB - width_3) + 1) | 0;
            const busSelectComp_3 = createComponent(new ComponentType(/* BusSelection */ 6, [width_3, (assignment.Slice.MSB - last.Slice.LSB) + 1]), "busSelect");
            const topCircuit_3 = new Circuit(singleton(busSelectComp_3), empty(), item_2(0, busSelectComp_3.OutputPorts), width_3);
            return sortBy((mapping_8) => mapping_8.Slice, append(ofArray([newFirst_1, assignment, new BitMapping(new Slice(last.Slice.MSB, newLastLSB_1), joinCircuits(singleton(last.Circuit), singleton(item_2(0, busSelectComp_3.InputPorts)), topCircuit_3), last.LHSType)]), filter((mapping_7) => !overlaps(assignment.Slice, mapping_7.Slice), bits)), {
                Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
            });
        }
    }
}

/**
 * returns a mapping from lhs variable name -> bits -> rhs final circuit
 * maybe store the bits in a sorted array instead of a map
 */
export function compileModule$0027(node, varToCompMap, ioToCompMap, varSizeMap, paramMap, arraySizeMap, arrayToCompMap) {
    const compileModule_1 = (node_1_mut, varToCompMap_1_mut, currCircuits_mut) => {
        compileModule_1:
        while (true) {
            const node_1 = node_1_mut, varToCompMap_1 = varToCompMap_1_mut, currCircuits = currCircuits_mut;
            let matchValue_1;
            switch (node_1.tag) {
                case 21: {
                    node_1_mut = (new ASTNode(/* Module */ 20, [convertModule(node_1.fields[0].Module)]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    continue compileModule_1;
                }
                case 20: {
                    node_1_mut = (new ASTNode(/* ModuleItems */ 19, [node_1.fields[0].ModuleItems]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    continue compileModule_1;
                }
                case 19:
                    return fold_2((circuits, item) => compileModule_1(new ASTNode(/* Item */ 18, [item]), varToCompMap_1, circuits), currCircuits, node_1.fields[0].ItemList);
                case 18: {
                    node_1_mut = getItem(node_1.fields[0]);
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    continue compileModule_1;
                }
                case 2: {
                    node_1_mut = (new ASTNode(/* Assignment */ 10, [node_1.fields[0].Assignment]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    continue compileModule_1;
                }
                case 10: {
                    const assign = node_1.fields[0];
                    const outPort = getPrimaryName(assign.LHS.PrimaryType);
                    const bits = sliceFromBits(assign.LHS, varToCompMap_1, varSizeMap, paramMap);
                    return add_1(outPort, addAssignment(new BitMapping(bits, mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, (bits.MSB - bits.LSB) + 1, arraySizeMap, arrayToCompMap), (tryFind(outPort, ioToCompMap) == null) ? LHSType.Wire : LHSType.OutputPort), (matchValue_1 = tryFind(outPort, currCircuits), (matchValue_1 != null) ? matchValue_1 : empty()), varToCompMap_1), currCircuits);
                }
                case 4: {
                    node_1_mut = (new ASTNode(/* Statement */ 5, [node_1.fields[0].Statement]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    continue compileModule_1;
                }
                case 5: {
                    const statement = node_1.fields[0];
                    switch (statement.tag) {
                        case 1: {
                            node_1_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            continue compileModule_1;
                        }
                        case 2:
                            return fold_2((circuits_1, stmt) => compileModule_1(new ASTNode(/* Statement */ 5, [stmt]), varToCompMap_1, circuits_1), currCircuits, statement.fields[0]);
                        case 4: {
                            const ifStmt = statement.fields[0];
                            const elseStmt = statement.fields[1];
                            const ifCircuits = compileModule_1(new ASTNode(/* Statement */ 5, [ifStmt.Statement]), varToCompMap_1, empty_2({
                                Compare: (x, y) => (comparePrimitives(x, y) | 0),
                            }));
                            const elseCircuits = (elseStmt != null) ? compileModule_1(new ASTNode(/* Statement */ 5, [elseStmt]), varToCompMap_1, empty_2({
                                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                            })) : empty_2({
                                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                            });
                            const condCircuit = mainExpressionCircuitBuilder(ifStmt.Condition, varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap);
                            return fold_1((circuits_2, var$) => fold((c, intervals) => {
                                if (intervals[0] == null) {
                                    if (intervals[1] != null) {
                                        const elseMapping_1 = intervals[1];
                                        return fold((c$0027_1, ifElse_1) => {
                                            const matchValue_6 = value_1(ifElse_1[0]);
                                            const matchValue_7 = value_1(ifElse_1[1]);
                                            const ifM_1 = matchValue_6;
                                            const mux_2 = createComponent(ComponentType.Mux2, var$);
                                            const topCircuit_2 = new Circuit(singleton(mux_2), empty(), item_2(0, mux_2.OutputPorts), ifM_1.Circuit.OutWidth);
                                            return add_1(var$, addAssignment(new BitMapping(ifM_1.Slice, joinCircuits(ofArray([matchValue_7.Circuit, ifM_1.Circuit, condCircuit]), ofArray([item_2(0, mux_2.InputPorts), item_2(1, mux_2.InputPorts), item_2(2, mux_2.InputPorts)]), topCircuit_2), ifM_1.LHSType), defaultArg(tryFind(var$, c$0027_1), empty()), varToCompMap_1), c$0027_1);
                                        }, c, filter((pair_1) => {
                                            if (pair_1[1] != null) {
                                                return pair_1[0] != null;
                                            }
                                            else {
                                                return false;
                                            }
                                        }, mergeIfElse(defaultArg(tryFind(var$, c), empty()), singleton(elseMapping_1), varToCompMap_1)));
                                    }
                                    else {
                                        return c;
                                    }
                                }
                                else if (intervals[1] == null) {
                                    const ifMapping_1 = intervals[0];
                                    return fold((c$0027, ifElse) => {
                                        const matchValue_4 = value_1(ifElse[0]);
                                        const matchValue_5 = value_1(ifElse[1]);
                                        const ifM = matchValue_4;
                                        const mux_1 = createComponent(ComponentType.Mux2, var$);
                                        const topCircuit_1 = new Circuit(singleton(mux_1), empty(), item_2(0, mux_1.OutputPorts), ifM.Circuit.OutWidth);
                                        return add_1(var$, addAssignment(new BitMapping(ifM.Slice, joinCircuits(ofArray([matchValue_5.Circuit, ifM.Circuit, condCircuit]), ofArray([item_2(0, mux_1.InputPorts), item_2(1, mux_1.InputPorts), item_2(2, mux_1.InputPorts)]), topCircuit_1), ifM.LHSType), defaultArg(tryFind(var$, c$0027), empty()), varToCompMap_1), c$0027);
                                    }, c, filter((pair) => {
                                        if (pair[1] != null) {
                                            return pair[0] != null;
                                        }
                                        else {
                                            return false;
                                        }
                                    }, mergeIfElse(singleton(ifMapping_1), defaultArg(tryFind(var$, c), empty()), varToCompMap_1)));
                                }
                                else {
                                    const elseMapping = intervals[1];
                                    const ifMapping = intervals[0];
                                    const mux = createComponent(ComponentType.Mux2, var$);
                                    const topCircuit = new Circuit(singleton(mux), empty(), item_2(0, mux.OutputPorts), ifMapping.Circuit.OutWidth);
                                    return add_1(var$, addAssignment(new BitMapping(ifMapping.Slice, joinCircuits(ofArray([elseMapping.Circuit, ifMapping.Circuit, condCircuit]), ofArray([item_2(0, mux.InputPorts), item_2(1, mux.InputPorts), item_2(2, mux.InputPorts)]), topCircuit), ifMapping.LHSType), defaultArg(tryFind(var$, c), empty()), varToCompMap_1), c);
                                }
                            }, circuits_2, mergeIfElse(defaultArg(tryFind(var$, ifCircuits), empty()), defaultArg(tryFind(var$, elseCircuits), empty()), varToCompMap_1)), currCircuits, union(ofSeq(FSharpMap__get_Keys(ifCircuits), {
                                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                            }), ofSeq(FSharpMap__get_Keys(elseCircuits), {
                                Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                            })));
                        }
                        case 5: {
                            node_1_mut = (new ASTNode(/* Statement */ 5, [unrollForLoops(statement.fields[0])]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            continue compileModule_1;
                        }
                        case 3: {
                            node_1_mut = (new ASTNode(/* Case */ 6, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            continue compileModule_1;
                        }
                        default: {
                            node_1_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            continue compileModule_1;
                        }
                    }
                }
                default:
                    return currCircuits;
            }
            break;
        }
    };
    return compileModule_1(node, varToCompMap, empty_2({
        Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
    }));
}

/**
 * debug:
 */
export function isCircuitValid$0027(comps, conns) {
    const inputPorts = map_6((port) => port.Id, collect((comp) => comp.InputPorts, comps));
    const outputPorts = map_6((port_1) => port_1.Id, collect((comp_1) => comp_1.OutputPorts, comps));
    if (isEmpty(filter((conn) => !(contains_1(conn.Source.Id, outputPorts, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }) && contains_1(conn.Target.Id, inputPorts, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })), conns))) {
        return true;
    }
    else {
        return false;
    }
}

/**
 * takes in n - number of inputs, must be a power of 2
 * circuit being returned has N (bus) data inputs and 1 select
 */
export function multiplexerNto1Circuit(inputs_mut, sel_mut) {
    multiplexerNto1Circuit:
    while (true) {
        const inputs = inputs_mut, sel = sel_mut;
        const n = length(inputs) | 0;
        switch (n) {
            case 0:
            case 1:
                return toFail(printf("Reached 1 or 0np in muxN creation, should not happen!"));
            case 2: {
                const mux = createComponent(ComponentType.Mux2, "mux2");
                const topCircuit = new Circuit(singleton(mux), empty(), item_2(0, mux.OutputPorts), 1);
                return joinCircuits(ofArray([item_2(1, inputs), item_2(0, inputs), sel]), ofArray([item_2(1, mux.InputPorts), item_2(0, mux.InputPorts), item_2(2, mux.InputPorts)]), topCircuit);
            }
            default: {
                const inputPairs = map_6((chunk) => {
                    let matchResult, first, second;
                    if (!isEmpty(chunk)) {
                        if (!isEmpty(tail_3(chunk))) {
                            if (isEmpty(tail_3(tail_3(chunk)))) {
                                matchResult = 0;
                                first = head_1(chunk);
                                second = head_1(tail_3(chunk));
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return [first, second];
                        default:
                            return toFail(printf("Invalid number of inputs for Nx1 multiplexer"));
                    }
                }, chunkBySize(2, inputs));
                const currSel = sliceCircuit(sel, 1, 0);
                const sel$0027 = sliceCircuit(sel, sel.OutWidth - 1, 1);
                inputs_mut = map_6((tupledArg) => multiplexerNto1Circuit(ofArray([tupledArg[0], tupledArg[1]]), currSel), inputPairs);
                sel_mut = sel$0027;
                continue multiplexerNto1Circuit;
            }
        }
        break;
    }
}

export function multiplexerCircuit(inputs, condition, defaultInput) {
    return fold((prevCircuit, tupledArg) => {
        const busComparator = createComponent(new ComponentType(/* BusCompare */ 47, [condition.OutWidth, tupledArg[0]]), "CMP");
        const topCircuit = new Circuit(singleton(busComparator), empty(), item_2(0, busComparator.OutputPorts), 1);
        const condCircuit = joinCircuits(singleton(condition), singleton(item_2(0, busComparator.InputPorts)), topCircuit);
        const mux2 = createComponent(ComponentType.Mux2, "mux2");
        const muxCircuit = new Circuit(singleton(mux2), empty(), item_2(0, mux2.OutputPorts), prevCircuit.OutWidth);
        return joinCircuits(ofArray([prevCircuit, tupledArg[1], condCircuit]), ofArray([item_2(0, mux2.InputPorts), item_2(1, mux2.InputPorts), item_2(2, mux2.InputPorts)]), muxCircuit);
    }, defaultInput, inputs);
}

export function parseParamName(name) {
    const matchValue = split(name, ["_P_"], undefined, 0);
    if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 1)) {
        return [item_3(0, matchValue), empty()];
    }
    else if (!equalsWith((x_1, y_1) => (x_1 === y_1), matchValue, defaultOf()) && (matchValue.length === 2)) {
        const paramString = item_3(1, matchValue);
        return [item_3(0, matchValue), ofArray(choose((_arg) => {
            if (!equalsWith((x_2, y_2) => (x_2 === y_2), _arg, defaultOf()) && (_arg.length === 2)) {
                return item_3(0, _arg);
            }
            else {
                return undefined;
            }
        }, chunkBySize_1(2, split(paramString, ["_"], undefined, 0))))];
    }
    else {
        return [name, empty()];
    }
}

export function isSameModuleIgnoringParams(name1, name2) {
    const patternInput = parseParamName(name1);
    const base1 = patternInput[0];
    const patternInput_1 = parseParamName(name2);
    const base2 = patternInput_1[0];
    if (((base1 === base2) && equals(patternInput[1], patternInput_1[1])) ? true : (base1 === name2)) {
        return true;
    }
    else {
        return base2 === name1;
    }
}

export function getInitialMapAndCircuits(veriloginput, project, paramMap) {
    const items = ofArray(convertModule(veriloginput.Module).ModuleItems.ItemList);
    const ioDecls = filter((_arg) => {
        if (_arg.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, items);
    const wiresLHS = collectWiresLHS(filter((_arg_1) => {
        if (_arg_1.tag === 3) {
            return true;
        }
        else {
            return false;
        }
    }, items));
    const ioToCompMap = filter_1((var$, _arg_2) => (var$ !== "clk"), getIOtoComponentMap(ioDecls, paramMap));
    const inputs = ofArray_1(map_7((id) => id.Name, fold((lst, item) => {
        if (item.tag === 0) {
            return append_1(lst, item.fields[0].Variables);
        }
        else {
            return toFail(printf("Should not happen! Expecting only IOItems"));
        }
    }, [], filter((_arg_3) => {
        let matchResult;
        if (_arg_3.tag === 0) {
            if (_arg_3.fields[0].DeclarationType.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }, ioDecls))), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    fold((map, wire) => getWireToCompMap(wire, map), ioToCompMap, wiresLHS);
    const patternInput = getPortSizeAndLocationMap(items, paramMap);
    const wireSizeMap = getWireSizeMap(items, paramMap);
    const declarations_1 = foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [veriloginput]));
    const arraySizeMap = getArraySizeMap(items, paramMap);
    const varSizeMap = fold_3((acc, key, value) => add_1(key, value, acc), fold((map_1, decl) => fold_2((map$0027, variable) => {
        if (containsKey(variable.Name, arraySizeMap)) {
            return map$0027;
        }
        else if (decl.Range == null) {
            return add_1(variable.Name, 1, map$0027);
        }
        else {
            return add_1(variable.Name, (evalExprWithParams(value_1(decl.Range).Start, paramMap) - evalExprWithParams(value_1(decl.Range).End, paramMap)) + 1, map$0027);
        }
    }, map_1, decl.Variables), wireSizeMap, declarations_1), patternInput[0]);
    const combVars = getCombinationalVars(veriloginput, project);
    const clockedVars = getClockedVars(veriloginput);
    const varToCompMap = fold((map_2, var$_1) => {
        const matchValue = tryFind(var$_1, arraySizeMap);
        if (matchValue == null) {
            return add_1(var$_1, createComponent(ComponentType.IOLabel, var$_1), map_2);
        }
        else {
            return map_2;
        }
    }, ioToCompMap, combVars);
    const combArrays = filter((var$_2) => containsKey(var$_2, arraySizeMap), combVars);
    const patternInput_2 = fold((tupledArg, var$_4) => {
        const varMap = tupledArg[0];
        const arrayMap = tupledArg[1];
        const matchValue_1 = tryFind(var$_4, varSizeMap);
        if (matchValue_1 != null) {
            return [add_1(var$_4, createComponent(new ComponentType(/* Register */ 33, [matchValue_1]), var$_4), varMap), arrayMap];
        }
        else {
            const matchValue_2 = tryFind(var$_4, arraySizeMap);
            if (matchValue_2 != null) {
                const s_1 = matchValue_2;
                dbg(256, `adding array ${var$_4} to the component map with size ${s_1}`);
                ~~Math.ceil(Math.log(item_3(0, s_1[1])) / Math.log(2));
                return [varMap, add_1(var$_4, createRegisterArray(var$_4, arraySizeMap), arrayMap)];
            }
            else {
                throw new Exception("What? variable doesn\'t have a size?");
            }
        }
    }, [varToCompMap, fold((map_3, var$_3) => {
        const patternInput_1 = find(var$_3, arraySizeMap);
        return add_1(var$_3, toList(delay(() => map_8((i) => createComponent(ComponentType.IOLabel, toText(printf("%s_%d"))(var$_3)(i)), rangeDouble(0, 1, item_3(0, patternInput_1[1]) - 1)))), map_3);
    }, empty_2({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), combArrays)], clockedVars);
    const varToCompMap_1 = patternInput_2[0];
    const arrayToCompMap_1 = patternInput_2[1];
    const clockedVarsSet = ofList_1(clockedVars, {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    return [varToCompMap_1, ioToCompMap, varSizeMap, filter_1((var$_6, _arg_4) => (var$_6 !== "clk"), fold_3((map_4, var$_5, width) => {
        const matchValue_3 = contains(var$_5, inputs);
        const matchValue_4 = contains(var$_5, clockedVarsSet);
        if (matchValue_3) {
            return map_4;
        }
        else if (matchValue_4) {
            let reg;
            const matchValue_6 = tryFind(var$_5, varToCompMap_1);
            reg = ((matchValue_6 != null) ? matchValue_6 : toFail(printf("Clocked variable doesn\'t have a component")));
            return add_1(var$_5, new Circuit(singleton(reg), empty(), item_2(0, reg.OutputPorts), width), map_4);
        }
        else {
            return add_1(var$_5, createNumberCircuit(new Number$(/* All */ 0, [width, BaseDU.Binary, "0", 100])), map_4);
        }
    }, empty_2({
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), varSizeMap)), fold_3((map_5, var$_7, dims) => {
        let matchValue_7, matchValue_8, matchValue_10;
        return filter_1((var$_8, _arg_5) => (var$_8 !== "clk"), (matchValue_7 = contains(var$_7, inputs), (matchValue_8 = contains(var$_7, clockedVarsSet), matchValue_7 ? toFail(printf("Arrays should not be accepted as IO")) : (matchValue_8 ? add_1(var$_7, map_6((comp_2) => (new Circuit(singleton(comp_2), empty(), item_2(0, comp_2.OutputPorts), dims[0])), (matchValue_10 = tryFind(var$_7, arrayToCompMap_1), (matchValue_10 != null) ? matchValue_10 : toFail(printf("Clocked variable doesn\'t have a component")))), map_5) : add_1(var$_7, toList(delay(() => map_8((i_1) => createNumberCircuit(new Number$(/* All */ 0, [dims[0], BaseDU.Binary, "0", 100])), rangeDouble(0, 1, item_3(0, dims[1]) - 1)))), map_5)))));
    }, empty_2({
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    }), arraySizeMap), map_6((id_1) => id_1.Name.toLocaleUpperCase(), collect((_arg_6) => {
        if (_arg_6.tag === 0) {
            return ofArray(_arg_6.fields[0].Variables);
        }
        else {
            return toFail(printf("Should not happen! Expecting only IOItems"));
        }
    }, ioDecls)), arraySizeMap, arrayToCompMap_1];
}

export function compileModule(node, varToCompMap, ioToCompMap, varSizeMap, paramMap, arraySizeMap, arrayToCompMap, initialCircuits, initialArrayCircuits, project, compName, model, dispatch) {
    const compileModuleRec = (node_1_mut, varToCompMap_1_mut, currCircuits_mut, currArrayCircuits_mut) => {
        compileModuleRec:
        while (true) {
            const node_1 = node_1_mut, varToCompMap_1 = varToCompMap_1_mut, currCircuits = currCircuits_mut, currArrayCircuits = currArrayCircuits_mut;
            let patternInput_1, matchValue_5, bits_2, rhsCircuit_1, currArrayCircuit_2, matchValue_6, indexCircuit_1, matchValue_7, rhsSource_2, patternInput_2, matchValue_8, outWidth_4, rhsCircuit_2, currArrayCircuit_3, matchValue_9, indexCircuit_2, rhsSource_3, patternInput_3, matchValue_10, outWidth_5, rhsCircuit_3, currArrayCircuit_4, matchValue_11, arrayIndexCircuit, matchValue_12, bitIndexCircuit, rhsSource_4, bitIndexSource, bits_1, patternInput, matchValue_2, currArrayCircuit_1, arrayElem_1, circuit_1, MSBs_1, newCircuit_1, matchValue_23, tupledArg_6, project_1, oldName;
            switch (node_1.tag) {
                case 21: {
                    node_1_mut = (new ASTNode(/* Module */ 20, [convertModule(node_1.fields[0].Module)]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    currArrayCircuits_mut = currArrayCircuits;
                    continue compileModuleRec;
                }
                case 20: {
                    node_1_mut = (new ASTNode(/* ModuleItems */ 19, [node_1.fields[0].ModuleItems]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    currArrayCircuits_mut = currArrayCircuits;
                    continue compileModuleRec;
                }
                case 19:
                    return fold_2((tupledArg, item) => compileModuleRec(new ASTNode(/* Item */ 18, [item]), varToCompMap_1, tupledArg[0], tupledArg[1]), [currCircuits, currArrayCircuits], node_1.fields[0].ItemList);
                case 18: {
                    node_1_mut = getItem(node_1.fields[0]);
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    currArrayCircuits_mut = currArrayCircuits;
                    continue compileModuleRec;
                }
                case 2: {
                    node_1_mut = (new ASTNode(/* Assignment */ 10, [node_1.fields[0].Assignment]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    currArrayCircuits_mut = currArrayCircuits;
                    continue compileModuleRec;
                }
                case 10: {
                    const assign = node_1.fields[0];
                    const outPort = getPrimaryName(assign.LHS.PrimaryType);
                    if (tryFind(outPort, arraySizeMap) != null) {
                    }
                    const compileVarSelCircuits = (outWidth, rhsSource, currSource, indexSource) => {
                        const rhsSource$0027 = extendCircuit(outWidth, rhsSource);
                        let shiftedRhs;
                        const shifter = createComponent(new ComponentType(/* Shift */ 46, [outWidth, indexSource.OutWidth, ShiftComponentType.LSL]), "SHIFT");
                        const topCircuit = new Circuit(singleton(shifter), empty(), item_2(0, shifter.OutputPorts), outWidth);
                        shiftedRhs = joinCircuits(ofArray([rhsSource$0027, indexSource]), ofArray([item_2(0, shifter.InputPorts), item_2(1, shifter.InputPorts)]), topCircuit);
                        const one = createNumberCircuit(new Number$(/* All */ 0, [outWidth, BaseDU.Decimal, "1", 100]));
                        let mask;
                        const shifter_1 = createComponent(new ComponentType(/* Shift */ 46, [outWidth, indexSource.OutWidth, ShiftComponentType.LSL]), "SHIFT");
                        const topCircuit_1 = new Circuit(singleton(shifter_1), empty(), item_2(0, shifter_1.OutputPorts), outWidth);
                        mask = joinCircuits(ofArray([one, indexSource]), ofArray([item_2(0, shifter_1.InputPorts), item_2(1, shifter_1.InputPorts)]), topCircuit_1);
                        let invertedMask;
                        const notComp = createComponent(new ComponentType(/* NbitsNot */ 23, [outWidth]), "NOT");
                        const topCircuit_2 = new Circuit(singleton(notComp), empty(), item_2(0, notComp.OutputPorts), outWidth);
                        invertedMask = joinCircuits(singleton(mask), singleton(item_2(0, notComp.InputPorts)), topCircuit_2);
                        let clearedCurr;
                        const andComp = createComponent(new ComponentType(/* NbitsAnd */ 22, [outWidth]), "AND");
                        const topCircuit_3 = new Circuit(singleton(andComp), empty(), item_2(0, andComp.OutputPorts), outWidth);
                        clearedCurr = joinCircuits(ofArray([currSource, invertedMask]), ofArray([item_2(0, andComp.InputPorts), item_2(1, andComp.InputPorts)]), topCircuit_3);
                        const orComp = createComponent(new ComponentType(/* NbitsOr */ 24, [outWidth]), "OR");
                        const topCircuit_4 = new Circuit(singleton(orComp), empty(), item_2(0, orComp.OutputPorts), outWidth);
                        return joinCircuits(ofArray([clearedCurr, shiftedRhs]), ofArray([item_2(0, orComp.InputPorts), item_2(1, orComp.InputPorts)]), topCircuit_4);
                    };
                    const compileVarSelArray = (outDim, outWidth_2, currSources, indexSource_3, makeUpdated) => mapIndexed((i_1, currSource_3) => {
                        const currSource_1 = currSource_3;
                        const updatedSource = makeUpdated(currSource_3);
                        let selector;
                        const indexSource_1 = indexSource_3;
                        const cmp = createComponent(new ComponentType(/* BusCompare */ 47, [indexSource_1.OutWidth, fromInt64(toInt64_unchecked(fromInt32(i_1)))]), "CMP");
                        const topCircuit_5 = new Circuit(singleton(cmp), empty(), item_2(0, cmp.OutputPorts), 1);
                        selector = joinCircuits(singleton(indexSource_1), singleton(item_2(0, cmp.InputPorts)), topCircuit_5);
                        const mux = createComponent(ComponentType.Mux2, "Mux2");
                        const topCircuit_6 = new Circuit(singleton(mux), empty(), item_2(0, mux.OutputPorts), currSource_1.OutWidth);
                        return joinCircuits(ofArray([currSource_1, updatedSource, selector]), ofArray([item_2(0, mux.InputPorts), item_2(1, mux.InputPorts), item_2(2, mux.InputPorts)]), topCircuit_6);
                    }, currSources);
                    const matchValue_13 = assign.LHS.PrimaryType;
                    switch (matchValue_13.tag) {
                        case 5:
                            return [currCircuits, add_1(outPort, (patternInput_1 = ((matchValue_5 = tryFind(outPort, arraySizeMap), (matchValue_5 == null) ? toFail(printf("Variable doesn\'t have a size?")) : [matchValue_5[0], item_3(0, matchValue_5[1])])), (bits_2 = sliceFromBitsArray(assign.LHS, arraySizeMap), (rhsCircuit_1 = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, (bits_2.MSB - bits_2.LSB) + 1, arraySizeMap, arrayToCompMap), (currArrayCircuit_2 = ((matchValue_6 = tryFind(outPort, currArrayCircuits), (matchValue_6 != null) ? matchValue_6 : toFail(printf("This should not happen, variable doesn\'t have a circuit")))), (indexCircuit_1 = mainExpressionCircuitBuilder((matchValue_7 = item_3(0, matchValue_13.fields[1]), (matchValue_7.tag === 1) ? matchValue_7.fields[0] : (new ExpressionDU(/* Unary */ 13, [new UnaryDU(/* Number */ 1, [new Number$(/* Unsigned */ 1, [matchValue_7.fields[0], 0])])]))), varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap), (rhsSource_2 = (new Circuit(empty(), empty(), rhsCircuit_1.Out, rhsCircuit_1.OutWidth)), compileVarSelArray(patternInput_1[1], patternInput_1[0], map_6((c_5) => (new Circuit(empty(), empty(), c_5.Out, c_5.OutWidth)), currArrayCircuit_2), new Circuit(empty(), empty(), indexCircuit_1.Out, indexCircuit_1.OutWidth), (currSource_4) => {
                                const MSBs_2 = (((currSource_4.OutWidth - bits_2.MSB) - 1) > 0) ? singleton(sliceCircuit(currSource_4, (currSource_4.OutWidth - bits_2.MSB) - 1, bits_2.MSB + 1)) : empty();
                                return joinWithMerge$0027(append((bits_2.LSB > 0) ? singleton(sliceCircuit(currSource_4, bits_2.LSB, 0)) : empty(), append(singleton(rhsSource_2), MSBs_2)));
                            }))))))), currArrayCircuits)];
                        case 3: {
                            const expr_3 = matchValue_13.fields[1];
                            if (containsKey(getPrimaryName(assign.LHS.PrimaryType), arraySizeMap)) {
                                return [currCircuits, add_1(outPort, (patternInput_2 = ((matchValue_8 = tryFind(outPort, arraySizeMap), (matchValue_8 == null) ? toFail(printf("Variable doesn\'t have a size?")) : [matchValue_8[0], item_3(0, matchValue_8[1])])), (outWidth_4 = (patternInput_2[0] | 0), (rhsCircuit_2 = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, outWidth_4, arraySizeMap, arrayToCompMap), (currArrayCircuit_3 = ((matchValue_9 = tryFind(outPort, currArrayCircuits), (matchValue_9 != null) ? matchValue_9 : toFail(printf("This should not happen, variable doesn\'t have a circuit")))), (indexCircuit_2 = mainExpressionCircuitBuilder(expr_3, varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap), (rhsSource_3 = (new Circuit(empty(), empty(), rhsCircuit_2.Out, rhsCircuit_2.OutWidth)), compileVarSelArray(patternInput_2[1], outWidth_4, map_6((c_7) => (new Circuit(empty(), empty(), c_7.Out, c_7.OutWidth)), currArrayCircuit_3), new Circuit(empty(), empty(), indexCircuit_2.Out, indexCircuit_2.OutWidth), (_arg) => rhsSource_3))))))), currArrayCircuits)];
                            }
                            else {
                                let outWidth_1;
                                const matchValue_3 = tryFind(outPort, varSizeMap);
                                outWidth_1 = ((matchValue_3 == null) ? toFail(printf("Variable doesn\'t have a size?")) : matchValue_3);
                                let currCircuit_1;
                                const matchValue_4 = tryFind(outPort, currCircuits);
                                currCircuit_1 = ((matchValue_4 != null) ? matchValue_4 : toFail(printf("This should not happen, variable doesn\'t have a circuit")));
                                const rhsCircuit = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, outWidth_1, arraySizeMap, arrayToCompMap);
                                const indexCircuit = mainExpressionCircuitBuilder(expr_3, varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap);
                                const updatedCircuit = compileVarSelCircuits(outWidth_1, new Circuit(empty(), empty(), rhsCircuit.Out, rhsCircuit.OutWidth), new Circuit(empty(), empty(), currCircuit_1.Out, currCircuit_1.OutWidth), new Circuit(empty(), empty(), indexCircuit.Out, indexCircuit.OutWidth));
                                return [add_1(outPort, new Circuit(append(currCircuit_1.Comps, append(rhsCircuit.Comps, append(indexCircuit.Comps, updatedCircuit.Comps))), append(currCircuit_1.Conns, append(rhsCircuit.Conns, append(indexCircuit.Conns, updatedCircuit.Conns))), updatedCircuit.Out, updatedCircuit.OutWidth), currCircuits), currArrayCircuits];
                            }
                        }
                        case 6:
                            return [currCircuits, add_1(outPort, (patternInput_3 = ((matchValue_10 = tryFind(outPort, arraySizeMap), (matchValue_10 == null) ? toFail(printf("Variable doesn\'t have a size?")) : [matchValue_10[0], item_3(0, matchValue_10[1])])), (outWidth_5 = (patternInput_3[0] | 0), (rhsCircuit_3 = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, 1, arraySizeMap, arrayToCompMap), (currArrayCircuit_4 = ((matchValue_11 = tryFind(outPort, currArrayCircuits), (matchValue_11 != null) ? matchValue_11 : toFail(printf("This should not happen, variable doesn\'t have a circuit")))), (arrayIndexCircuit = mainExpressionCircuitBuilder((matchValue_12 = item_3(0, matchValue_13.fields[1]), (matchValue_12.tag === 1) ? matchValue_12.fields[0] : (new ExpressionDU(/* Unary */ 13, [new UnaryDU(/* Number */ 1, [new Number$(/* Unsigned */ 1, [matchValue_12.fields[0], 0])])]))), varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap), (bitIndexCircuit = mainExpressionCircuitBuilder(matchValue_13.fields[2], varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap), (rhsSource_4 = (new Circuit(empty(), empty(), rhsCircuit_3.Out, rhsCircuit_3.OutWidth)), (bitIndexSource = (new Circuit(empty(), empty(), bitIndexCircuit.Out, bitIndexCircuit.OutWidth)), compileVarSelArray(patternInput_3[1], outWidth_5, map_6((c_9) => (new Circuit(empty(), empty(), c_9.Out, c_9.OutWidth)), currArrayCircuit_4), new Circuit(empty(), empty(), arrayIndexCircuit.Out, arrayIndexCircuit.OutWidth), (currSource_5) => compileVarSelCircuits(outWidth_5, rhsSource_4, currSource_5, bitIndexSource)))))))))), currArrayCircuits)];
                        default:
                            if (containsKey(getPrimaryName(assign.LHS.PrimaryType), arraySizeMap)) {
                                return [currCircuits, add_1(outPort, (bits_1 = sliceFromBitsArray(assign.LHS, arraySizeMap), (patternInput = [sliceFromWordArray(assign.LHS, varSizeMap, arraySizeMap), (matchValue_2 = tryFind(outPort, currArrayCircuits), (matchValue_2 != null) ? matchValue_2 : toFail(printf("This should not happen, variable doesn\'t have a circuit")))], (currArrayCircuit_1 = patternInput[1], (arrayElem_1 = (patternInput[0] | 0), (circuit_1 = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, (bits_1.MSB - bits_1.LSB) + 1, arraySizeMap, arrayToCompMap), (MSBs_1 = ((((item_2(arrayElem_1, currArrayCircuit_1).OutWidth - bits_1.MSB) - 1) > 0) ? singleton(sliceCircuit(item_2(arrayElem_1, currArrayCircuit_1), (item_2(arrayElem_1, currArrayCircuit_1).OutWidth - bits_1.MSB) - 1, bits_1.MSB + 1)) : empty()), (newCircuit_1 = joinWithMerge$0027(append((bits_1.LSB > 0) ? singleton(sliceCircuit(item_2(arrayElem_1, currArrayCircuit_1), bits_1.LSB, 0)) : empty(), append(singleton(circuit_1), MSBs_1))), mapIndexed((i, c_2) => ((i === arrayElem_1) ? newCircuit_1 : c_2), currArrayCircuit_1)))))))), currArrayCircuits)];
                            }
                            else {
                                const currCircuits_1 = currCircuits;
                                const bits = sliceFromBits(assign.LHS, varToCompMap_1, varSizeMap, paramMap);
                                const circuit = mainExpressionCircuitBuilder(assign.RHS, varToCompMap_1, varSizeMap, paramMap, (bits.MSB - bits.LSB) + 1, arraySizeMap, arrayToCompMap);
                                let currCircuit;
                                const matchValue_1 = tryFind(outPort, currCircuits_1);
                                currCircuit = ((matchValue_1 != null) ? matchValue_1 : toFail(printf("This should not happen, variable doesn\'t have a circuit")));
                                const MSBs = (((currCircuit.OutWidth - bits.MSB) - 1) > 0) ? singleton(sliceCircuit(currCircuit, (currCircuit.OutWidth - bits.MSB) - 1, bits.MSB + 1)) : empty();
                                return [add_1(outPort, joinWithMerge$0027(append((bits.LSB > 0) ? singleton(sliceCircuit(currCircuit, bits.LSB, 0)) : empty(), append(singleton(circuit), MSBs))), currCircuits_1), currArrayCircuits];
                            }
                    }
                }
                case 4: {
                    node_1_mut = (new ASTNode(/* Statement */ 5, [node_1.fields[0].Statement]));
                    varToCompMap_1_mut = varToCompMap_1;
                    currCircuits_mut = currCircuits;
                    currArrayCircuits_mut = currArrayCircuits;
                    continue compileModuleRec;
                }
                case 5: {
                    const statement = node_1.fields[0];
                    switch (statement.tag) {
                        case 1: {
                            node_1_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            currArrayCircuits_mut = currArrayCircuits;
                            continue compileModuleRec;
                        }
                        case 2:
                            return fold_2((tupledArg_1, stmt) => compileModuleRec(new ASTNode(/* Statement */ 5, [stmt]), varToCompMap_1, tupledArg_1[0], tupledArg_1[1]), [currCircuits, currArrayCircuits], statement.fields[0]);
                        case 4: {
                            const ifStmt = statement.fields[0];
                            const elseStmt = statement.fields[1];
                            const patternInput_4 = compileModuleRec(new ASTNode(/* Statement */ 5, [ifStmt.Statement]), varToCompMap_1, currCircuits, currArrayCircuits);
                            const ifArrayCircuits = patternInput_4[1];
                            const patternInput_5 = (elseStmt != null) ? compileModuleRec(new ASTNode(/* Statement */ 5, [elseStmt]), varToCompMap_1, currCircuits, currArrayCircuits) : [currCircuits, currArrayCircuits];
                            const condCircuit = mainExpressionCircuitBuilder(ifStmt.Condition, varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap);
                            const comp = createComponent(new ComponentType(/* BusCompare */ 47, [condCircuit.OutWidth, fromZero()]), "CMP");
                            const topCircuit_7 = new Circuit(singleton(comp), empty(), item_2(0, comp.OutputPorts), 1);
                            const condCircuitN = joinCircuits(singleton(condCircuit), singleton(item_2(0, comp.InputPorts)), topCircuit_7);
                            return [fold_3((circuits_2, var$, ifCircuit) => {
                                let elseCircuit;
                                const matchValue_14 = tryFind(var$, patternInput_5[0]);
                                elseCircuit = ((matchValue_14 != null) ? matchValue_14 : toFail(printf("This should not happen variable doesn\'t have a circuit in else branch!")));
                                if (equals(ifCircuit, elseCircuit)) {
                                    return circuits_2;
                                }
                                else {
                                    const mux_1 = createComponent(ComponentType.Mux2, "Mux2");
                                    const topCircuit_8 = new Circuit(singleton(mux_1), empty(), item_2(0, mux_1.OutputPorts), ifCircuit.OutWidth);
                                    return add_1(var$, joinCircuits(ofArray([ifCircuit, elseCircuit, condCircuitN]), ofArray([item_2(0, mux_1.InputPorts), item_2(1, mux_1.InputPorts), item_2(2, mux_1.InputPorts)]), topCircuit_8), circuits_2);
                                }
                            }, currCircuits, patternInput_4[0]), ifArrayCircuits.Equals(patternInput_5[1]) ? ifArrayCircuits : currArrayCircuits];
                        }
                        case 5: {
                            const forStmt = statement.fields[0];
                            node_1_mut = (new ASTNode(/* Statement */ 5, [unrollForLoops(forStmt)]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = FSharpMap__Remove(currCircuits, getPrimaryName(forStmt.Initialisation.LHS.PrimaryType));
                            currArrayCircuits_mut = currArrayCircuits;
                            continue compileModuleRec;
                        }
                        case 3: {
                            node_1_mut = (new ASTNode(/* Case */ 6, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            currArrayCircuits_mut = currArrayCircuits;
                            continue compileModuleRec;
                        }
                        default: {
                            node_1_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            varToCompMap_1_mut = varToCompMap_1;
                            currCircuits_mut = currCircuits;
                            currArrayCircuits_mut = currArrayCircuits;
                            continue compileModuleRec;
                        }
                    }
                }
                case 6: {
                    const case$_1 = node_1.fields[0];
                    const caseItemMap = fold_2((map, caseItem) => fold_2((m_1, num) => {
                        let numBase;
                        return add_1((num.tag === 0) ? ((numBase = num.fields[1], toDecimal(num.fields[2], (numBase.tag === 2) ? "\'h" : ((numBase.tag === 1) ? "\'d" : "\'b"), int32ToString(num.fields[0])))) : fromInt32(num.fields[0]), caseItem.Statement, m_1);
                    }, map, caseItem.Expressions), empty_2({
                        Compare: (x, y) => (compare_1(x, y) | 0),
                    }), case$_1.CaseItems);
                    const muxInputs = fold_3((inputs, num_1, stmt_2) => fold_3((currMap, var$_1, circuit_2) => {
                        let matchValue_15;
                        return add_1(var$_1, (matchValue_15 = tryFind(var$_1, currMap), (matchValue_15 != null) ? append(matchValue_15, singleton([num_1, circuit_2])) : singleton([num_1, circuit_2])), currMap);
                    }, inputs, compileModuleRec(new ASTNode(/* Statement */ 5, [stmt_2]), varToCompMap_1, currCircuits, currArrayCircuits)[0]), empty_2({
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    }), caseItemMap);
                    let patternInput_7;
                    const matchValue_16 = case$_1.Default;
                    patternInput_7 = ((matchValue_16 == null) ? [currCircuits, currArrayCircuits] : compileModuleRec(new ASTNode(/* Statement */ 5, [matchValue_16]), varToCompMap_1, currCircuits, currArrayCircuits));
                    const sel = mainExpressionCircuitBuilder(case$_1.Expression, varToCompMap_1, varSizeMap, paramMap, 0, arraySizeMap, arrayToCompMap);
                    return [fold_3((circuits_4, var$_2, inputs_1) => {
                        let matchValue_17;
                        return add_1(var$_2, multiplexerCircuit(inputs_1, sel, (matchValue_17 = tryFind(var$_2, patternInput_7[0]), (matchValue_17 != null) ? matchValue_17 : toFail(printf("What? Variable doesn\'t have a circuit in the default case")))), circuits_4);
                    }, currCircuits, muxInputs), currArrayCircuits];
                }
                case 22: {
                    const modInst = node_1.fields[0];
                    let loadedComp;
                    const matchValue_18 = tryFind_1((comp_1) => (comp_1.Name === modInst.Module.Name), project.LoadedComponents);
                    loadedComp = ((matchValue_18 != null) ? matchValue_18 : toFail(printf("No such loaded component found, this should never happen %s"))(modInst.Module.Name));
                    let patternInput_10;
                    const matchValue_19 = modInst.Parameters;
                    if (matchValue_19 == null) {
                        patternInput_10 = [loadedComp, modInst.Module.Name];
                    }
                    else {
                        const parameters = matchValue_19;
                        const overrideMap = fold_2((map_1, param) => add_1(param.Identifier.Name, evalExpr(param.Value), map_1), empty_2({
                            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                        }), parameters);
                        const original_name = modInst.Module.Name;
                        const name = (modInst.Module.Name + "_P_") + StringModule_Concat("_", map_6((tupledArg_2) => toText(printf("%s_%A"))(tupledArg_2[0])(tupledArg_2[1]), toList_1(overrideMap)));
                        const matchValue_20 = tryFind_1((comp_3) => (comp_3.Name === name), project.LoadedComponents);
                        if (matchValue_20 != null) {
                            patternInput_10 = [matchValue_20, name];
                        }
                        else {
                            let modInstVerilog;
                            const matchValue_21 = loadedComp.Form;
                            let matchResult, name_1;
                            if (matchValue_21 != null) {
                                if (matchValue_21.tag === 4) {
                                    matchResult = 0;
                                    name_1 = matchValue_21.fields[0];
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    let code;
                                    const matchValue_22 = tryReadFileSync(pathJoin([project.ProjectPath, name_1 + ".v"]));
                                    code = ((matchValue_22.tag === 1) ? toText(printf("Error: file {%s.v} has been deleted from the project directory"))(name_1) : matchValue_22.fields[0]);
                                    const result = value_1(((matchValue_23 = SimpleJson_tryParse(parseFromFile(code)), (matchValue_23 != null) ? Convert_fromJson(matchValue_23, createTypeInfo(ParserOutput_$reflection())) : (() => {
                                        throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
                                    })())).Result);
                                    const matchValue_24 = SimpleJson_tryParse(fix(result));
                                    if (matchValue_24 != null) {
                                        modInstVerilog = Convert_fromJson(matchValue_24, createTypeInfo(VerilogInput_$reflection()));
                                    }
                                    else {
                                        throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
                                    }
                                    break;
                                }
                                default:
                                    modInstVerilog = toFail(printf("Loaded component doesn\'t have a form - Only verilog modules supported currently"));
                            }
                            const folderPath_1 = project.ProjectPath;
                            let code_1;
                            const matchValue_25 = tryReadFileSync(pathJoin([folderPath_1, original_name + ".v"]));
                            code_1 = ((matchValue_25.tag === 1) ? toText(printf("Error: file {%s.v} has been deleted from the project directory"))(original_name) : matchValue_25.fields[0]);
                            const path_1 = pathJoin([folderPath_1, name + ".v"]);
                            const path2 = pathJoin([folderPath_1, name + ".dgm"]);
                            const matchValue_26 = writeFile(path_1, code_1);
                            if (matchValue_26.tag === 1) {
                                toFail(printf("Writing verilog file FAILED"));
                            }
                            ofArray(convertModule(modInstVerilog.Module).ModuleItems.ItemList);
                            const patternInput_8 = getInitialMapAndCircuits(modInstVerilog, project, overrideMap);
                            const varToCompMap_2 = patternInput_8[0];
                            const ioVars = patternInput_8[5];
                            const ioToCompMap_1 = patternInput_8[1];
                            const csList = map_6((tupledArg_4) => attachToOutput(varToCompMap_2, ioToCompMap_1, tupledArg_4[1], tupledArg_4[0]), sortBy((tupledArg_3) => (defaultArg(tryFindIndex((var$_3) => (var$_3 === tupledArg_3[0]), ioVars), -1) | 0), toList_1(compileModule(new ASTNode(/* VerilogInput */ 21, [modInstVerilog]), varToCompMap_2, ioToCompMap_1, patternInput_8[2], overrideMap, patternInput_8[6], patternInput_8[7], patternInput_8[3], patternInput_8[4], project, compName, model, dispatch)[0]), {
                                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                            }));
                            map_6((cs) => cs, csList);
                            let finalCanvasState;
                            if (isEmpty(csList)) {
                                finalCanvasState = [collectInputAndWireComps(varToCompMap_2), empty()];
                            }
                            else {
                                const tupledArg_5 = reduce((cs1, cs2) => concatenateCanvasStates(cs1[0], cs1[1], cs2[0], cs2[1]), csList);
                                finalCanvasState = concatenateCanvasStates(collectInputAndWireComps(varToCompMap_2), empty(), tupledArg_5[0], tupledArg_5[1]);
                            }
                            const matchValue_28 = Result_Bind((data) => writeFile(path2, data), JsonHelpers_stateToJsonString((tupledArg_6 = [sortBy((c_13) => (defaultArg(tryFindIndex((var$_4) => (var$_4 === c_13.Label), ioVars), -1) | 0), finalCanvasState[0], {
                                Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                            }), finalCanvasState[1]], fixCanvasState(tupledArg_6[0], tupledArg_6[1])), undefined, new SheetInfo(new CCForm(/* Verilog */ 4, [name]), undefined, undefined, undefined, undefined)));
                            if (matchValue_28.tag === 1) {
                                patternInput_10 = toFail(printf("Writing .dgm file FAILED"));
                            }
                            else {
                                let nestedComponent;
                                const matchValue_29 = tryLoadComponentFromPath(path2);
                                nestedComponent = ((matchValue_29.tag === 1) ? toFail(printf("failed to load the created Verilog file")) : matchValue_29.fields[0]);
                                openFileInProject(project.OpenFileName, (project_1 = (new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, cons(nestedComponent, project.LoadedComponents))), (oldName = modInst.Module.Name, new Project(project_1.ProjectPath, project_1.OpenFileName, project_1.WorkingFileName, map_6((ldc) => {
                                    let cs_1;
                                    if (ldc.Name === compName) {
                                        return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, (cs_1 = ldc.CanvasState, [map_6((comp_6) => {
                                            let ct_1;
                                            const matchValue_30 = comp_6.Type;
                                            let matchResult_1, ct_2;
                                            if (matchValue_30.tag === 26) {
                                                if ((ct_1 = matchValue_30.fields[0], isSameModuleIgnoringParams(ct_1.Name, oldName) ? true : (ct_1.Name === oldName))) {
                                                    matchResult_1 = 0;
                                                    ct_2 = matchValue_30.fields[0];
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_1 = 1;
                                            }
                                            switch (matchResult_1) {
                                                case 0:
                                                    return new Component(comp_6.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(name, ct_2.InputLabels, ct_2.OutputLabels, ct_2.Form, ct_2.ParameterBindings, ct_2.Description)]), comp_6.Label, comp_6.InputPorts, comp_6.OutputPorts, comp_6.X, comp_6.Y, comp_6.H, comp_6.W, comp_6.SymbolInfo, comp_6.SlotInfo);
                                                default:
                                                    return comp_6;
                                            }
                                        }, cs_1[0]), cs_1[1]]), ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
                                    }
                                    else {
                                        return ldc;
                                    }
                                }, project_1.LoadedComponents)))), model, dispatch);
                                patternInput_10 = [nestedComponent, name];
                            }
                        }
                    }
                    const loadedComp_1 = patternInput_10[0];
                    const comp_7 = createComponent(new ComponentType(/* Custom */ 26, [new CustomComponentType(patternInput_10[1], loadedComp_1.InputLabels, loadedComp_1.OutputLabels, undefined, undefined, undefined)]), modInst.Identifier.Name);
                    const portLabels = append(loadedComp_1.InputLabels, loadedComp_1.OutputLabels);
                    const connections = ofArray(map_7((conn_1) => conn_1.Primary, sortBy_1((conn) => {
                        const matchValue_31 = tryFindIndex((tupledArg_7) => (tupledArg_7[0] === conn.PortId.Name.toLocaleUpperCase()), portLabels);
                        if (matchValue_31 != null) {
                            return matchValue_31 | 0;
                        }
                        else {
                            return toFail(printf("portId doesn\'t exist, should never happen")) | 0;
                        }
                    }, modInst.Connections, {
                        Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
                    })));
                    const patternInput_11 = splitAt(length(loadedComp_1.InputLabels), connections);
                    const inputCircuit = joinCircuits(map_6((primary) => createPrimaryCircuit(primary, varToCompMap_1, varSizeMap, paramMap), patternInput_11[0]), comp_7.InputPorts, new Circuit(singleton(comp_7), empty(), item_2(0, comp_7.OutputPorts), 0));
                    return [fold((circuits_5, tupledArg_8) => {
                        const primary_1 = tupledArg_8[0];
                        const outPort_1 = getPrimaryName(primary_1);
                        const bits_4 = sliceFromBitsPrimary(primary_1, varToCompMap_1, varSizeMap, paramMap);
                        const circuit_4 = new Circuit(inputCircuit.Comps, inputCircuit.Conns, tupledArg_8[1], (bits_4.MSB - bits_4.LSB) + 1);
                        let currCircuit_2;
                        const matchValue_32 = tryFind(outPort_1, circuits_5);
                        currCircuit_2 = ((matchValue_32 != null) ? matchValue_32 : toFail(printf("This should not happen, variable doesn\'t have a circuit")));
                        const MSBs_3 = (((currCircuit_2.OutWidth - bits_4.MSB) - 1) > 0) ? singleton(sliceCircuit(currCircuit_2, (currCircuit_2.OutWidth - bits_4.MSB) - 1, bits_4.MSB + 1)) : empty();
                        return add_1(outPort_1, joinWithMerge$0027(append((bits_4.LSB > 0) ? singleton(sliceCircuit(currCircuit_2, bits_4.LSB, 0)) : empty(), append(singleton(circuit_4), MSBs_3))), circuits_5);
                    }, currCircuits, zip(patternInput_11[1], comp_7.OutputPorts)), currArrayCircuits];
                }
                default:
                    return [currCircuits, currArrayCircuits];
            }
            break;
        }
    };
    return compileModuleRec(node, varToCompMap, initialCircuits, initialArrayCircuits);
}

export function createSheet(veriloginput, project, model, dispatch) {
    const input = convertModule(veriloginput.Module);
    const paramMap = getParamMap(veriloginput, empty(), ofArray(input.ModuleItems.ItemList))[0];
    const patternInput_1 = getInitialMapAndCircuits(veriloginput, project, paramMap);
    const varToCompMap = patternInput_1[0];
    const ioVars = patternInput_1[5];
    const ioToCompMap = patternInput_1[1];
    const arrayToCompMap = patternInput_1[7];
    const patternInput_2 = compileModule(new ASTNode(/* VerilogInput */ 21, [veriloginput]), varToCompMap, ioToCompMap, patternInput_1[2], paramMap, patternInput_1[6], arrayToCompMap, patternInput_1[3], patternInput_1[4], project, input.ModuleName.Name, model, dispatch);
    const perItemCircuits_1 = sortBy((tupledArg) => (defaultArg(tryFindIndex((var$) => (var$ === tupledArg[0]), ioVars), -1) | 0), toList_1(patternInput_2[0]), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const perArrayCircuits_1 = sortBy((tupledArg_1) => (defaultArg(tryFindIndex((var$_1) => (var$_1 === tupledArg_1[0]), ioVars), -1) | 0), toList_1(patternInput_2[1]), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    const csList_1 = append(map_6((tupledArg_2) => attachToOutput(varToCompMap, ioToCompMap, tupledArg_2[1], tupledArg_2[0]), perItemCircuits_1), map_6((tupledArg_3) => attachArrayToOutput(arrayToCompMap, tupledArg_3[1], tupledArg_3[0]), perArrayCircuits_1));
    map_6((cs) => cs, csList_1);
    let finalCanvasState;
    if (isEmpty(csList_1)) {
        finalCanvasState = [collectInputAndWireComps(varToCompMap), empty()];
    }
    else {
        const tupledArg_4 = reduce((cs1, cs2) => concatenateCanvasStates(cs1[0], cs1[1], cs2[0], cs2[1]), csList_1);
        finalCanvasState = concatenateCanvasStates(collectInputAndWireComps(varToCompMap), empty(), tupledArg_4[0], tupledArg_4[1]);
    }
    let finalCanvasState_1;
    const tupledArg_5 = [sortBy((c_2) => (defaultArg(tryFindIndex((var$_2) => (var$_2 === c_2.Label), ioVars), -1) | 0), finalCanvasState[0], {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), finalCanvasState[1]];
    finalCanvasState_1 = fixCanvasState(tupledArg_5[0], tupledArg_5[1]);
    return layoutCanvas(sortBy((c_3) => (defaultArg(tryFindIndex((var$_3) => (var$_3 === c_3.Label), ioVars), -1) | 0), finalCanvasState_1[0], {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), finalCanvasState_1[1]);
}

